export default {
  common: {
    common_01: 'An error occurred.',
    all: 'Total',
    sold_out: 'Sold out',
    currency: '${{price}}',
    마플샵: 'MarppleShop',
  },
  crew: {
    authorization: {
      signup_00: 'Sign up',
      signup_01: 'Email',
      signup_02: 'Name',
      signup_03: 'Employee number',
      signup_04: 'Agreement to Terms of Use',
      signup_05: 'Personal Information Use Agreement',
      signup_06: 'Agreement to Provide Personal Information to Third Parties',
      signup_07: 'Confirmation of age 14 and over',
      signup_08: '[Optional] Agreement to receive email marketing',
      signup_09: 'View',
      signup_10: 'Log in',
      signup_11: 'Please agree to the terms of use.',
      signup_12: 'Please agree to the collection and use of personal information.',
      signup_13: 'Please agree to the provision of personal information to third parties.',
      signup_14: 'Only those aged 14 and over can sign up.',
      signup_15: 'An existing user already exists. Please check.',
      signup_17: 'Verification has not been completed.',
      signup_18: 'Affiliated corporations are not eligible for NBOX services',
      signup_18_mobile: 'The affiliated corporation is<br/>not eligible for NBOX service.',
    },
    crew_01: 'Go to home',
    suspensions: {
      type: {
        copyright: 'Copyright Infringement',
        counterfeit: 'Counterfeit Product Sale',
        adult_policy_violation: 'Adult Verification Policy Violation',
        internal_policy_violation: 'Marpple Shop Policy Violation',
      },
      user_type: {
        individual: 'Individual',
        group: 'Organization',
      },
    },
    solutions: {
      status: {
        answer: 'Response Completed',
        not_answer: 'Awaiting Response',
        not_selling: 'Sales Suspended',
        selling: 'Resume sales',
        suspension: 'Shop Suspended',
        not_suspension: 'Shop Active',
      },
      header: {
        title: 'Report Received',
        description: 'You can check reports submitted for your shop or products.',
      },
      table: {
        suspension_reason: {
          copyright: '{{count}} Copyright Infringements',
          counterfeit: '{{count}} Counterfeit Items Sold',
          adult_policy_violation: '{{count}} Adult Verification Policy Violations',
          internal_policy_violation: '{{count}} Internal Policy Violations',
        },
      },
      thread_status: {
        in_progress: '{{day}} days remaining in the response period.',
        re_in_progress: '{{day}} day(s) left to request again.',
        answer_expiration: 'Reapplication Period Expired / Thread Closed',
        end: 'Thread Closed',
      },
      form: {
        type: 'Report type',
        user_type: 'Those whose rights were infringed',
        name: 'Reporting receiver',
        birth: 'Date of birth',
        owner: 'Owner of the trademark / design right',
        owner_placeholder: 'Please enter your name, company name, or organization name.',
        contact: 'Contact',
        email: 'e-mail',
        email_placeholder: 'Please enter your email.',
        email_description:
          'The process of the reporting will be sent to the e-mail and contact above. Be sure to describe in an accurate manner.',
        product_url: 'Report product URL',
        product_url_placeholder: 'ex) https://marpple.shop/kr/shop_domain/products/12345',
        store_url: 'Creator Shop URL',
        store_url_placeholder: 'ex) https://marpple.shop/kr/shop_domain',
        product_info: 'Product Information',
        reason: 'Reason for reporting',
        reason_placeholder: 'Please provide detailed information for smooth report submission.',
        submit: 'Receive roporting',
        thread_submit: 'Create Thread',
        answer: 'Reply',
        file: 'Attachment',
        description: 'Details',
        confirm: 'You won’t be able to edit the report after submission.\nDo you want to proceed\n',
        required_document: 'Required Documents',
        required_document_description:
          'Please attach evidence of trademark/design infringement and its relation to the creator. (File size: under 10MB)',
        user_document: 'Organization Verification Document',
        user_document_description:
          'If this is a company/organization\nand the submitter is not the representative',
      },
      item: {
        report_type: 'Type',
        reported_creator: 'Reported Creator',
        reported_product_url: 'Reported Product URL',
        report_detail: 'Report Details',
        reportor_email: 'Reporter Email',
      },
    },
  },
  customer_orders: {
    pick_up: 'Pickup',
    possible_pick_up: 'Available for pickup',
    re_purchase: 'Repurchase',
    empty_order_desc: 'No orders yet',
    cannot_purchase: 'Purchase Unavailable',
    cannot_purchase_desc: 'You cannot purchase the product!',
  },
  layout: {
    footer1: 'MARPPLE Corporation',
    footer2: 'Customer center',
    footer3: 'Report center',
    footer4: 'Seller application',
    footer5: 'Corporate seller application',
    footer6: 'Privacy Policy',
    footer7: 'Terms of Use',
    footer8:
      'For Creator Delivery Products, MARPPLE Corporation is not a party to the telecommunications sale as an intermediary, and is not responsible for the product transaction or transaction information.',
    footer9: '© 2025 MARPPLE CORP.',
    footer: {
      company_name: 'MARPPLE Corporation',
      ceo: 'Representative',
      ceo_name: 'Park Hye-yoon',
      customer_center: 'Customer Center',
      customer_center_info: 'Weekdays 10:00 ~ 18:00',
      company_registration_info: 'Business Registration Number',
      company_registration_number: '105-88-13322',
      address: 'Address',
      address_info: '10th Floor, IS Biz Tower, 75-24 Gasan Digital 1-ro, Geumcheon-gu, Seoul',
      email: 'Email',
      report_center: 'Report center',
      apply_seller: 'Seller application',
      terms_and_conditions: 'Terms of Use',
      privacy_policy: 'Privacy Policy',
      instagram: 'Instagram',
      youtube: 'YouTube',
      twitter: 'Twitter',
      blog: 'Blog',
      marpple_corp: 'MARPPLE Corporation',
      nbox: {
        address: '7, Pangyo-ro 256beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea',
        phone: 'Phone',
        phone_number: '{{tel}}(On weekdays 10:00 ~ 18:00)',
        company_registration_number: '220-87-17483',
        ceo_name: 'Jeongheon Lee',
        footer1: 'Nexon Korea',
        footer9: '© NEXON Korea Corporation All Rights Reserved.',
      },
    },
    drawer: {
      menu: {
        review: 'Review',
        product: 'Official Product',
        home: 'Home',
      },
    },
  },
  my_page: {
    my_page_01: 'Hello <b>{{name}}</b> 👋',
    my_account_01: 'Profile Image',
    my_account_02: 'Please upload an image file within 10MB.<br/>(Image upload format: JPG, JPEG, PNG)',
    my_account_03: 'No file present.',
    my_account_04: 'Login is required.',
    my_account_05: 'File was not saved.',
    my_account_06: 'Delete',
    my_account_07: 'Update',
    my_account_08: 'Upload',
    like_product_01: 'Like',
    like_product_02: 'There is no product that you like.',
    nick_name: 'Nickname',
    save: 'Save',
    email: 'Email',
    mobile: 'Number',
    validation_nickname:
      'Only Korean, English letters, and numbers can be entered, and up to 16 bytes can be registered.',
    agree_email: 'Receive ads',
    view_agree_email: 'View',
    no_email: 'No registered email address.',
    file_valid_5mb: 'Please upload a file smaller than 5MB.',
    file_valid_fail: 'File upload failed.',
  },
  order: {
    '배송지 변경': 'Change shipping address',
    recipient: 'Recipient',
  },
  checkout: {
    receipt: {
      receipt_01: 'Your order has been completed.',
      receipt_01_mobile: '{{nickname}}!',
      receipt_01_compact: 'Your order has been completed.',
      receipt_02: 'Please wait with excitement!',
      receipt_02_compact: "We'll ship it with a special touch.<br/>Please wait with excitement!",
      download_purchase_card: 'Download your purchase authentication card.',
    },
  },
  product: {
    sort: {
      최신순: 'Most Recent',
      '리뷰 많은 순': 'Most Reviewed',
      인기순: 'Most Popular',
      '낮은 가격 순': 'Lowest Price',
      '높은 가격 순': 'Highest Price',
    },
    review: {
      count: 'Product Review',
      score: 'Rating',
    },
    n_viewing: {
      normal: '<b>{{n}}</b><span>fans watching this now!</span>',
      compact: '{{n}} people are watching',
    },
  },
  plus_admin: {
    plus_admin_01: 'Theme Selection',
    plus_admin_02: 'Black Theme',
    plus_admin_03: 'White Theme',
    banner_01: 'Subtitle',
    banner_02: 'Supports multiple languages, preview available on the left as you input.',
    banner_03: 'Title',
    plus_admin_04: 'Choose background color',
    popup_store: {
      list_page_title: 'Popup Store Management',
      detail_page_title: 'Popup Store Management',
      detail_page_desc:
        'Recommended Image Size : Width 3840px * Height 2000px / Supported Formats: JPG, JPEG, PNG, GIF, WEBP / Size: Up to 8MB',
    },
  },
  home: {
    plus_home: {
      plus_home_01: 'Popular Product',
      plus_home_02: 'Most loved official product',
      plus_home_03: "Grab it before it's too late!",
      plus_home_04: 'The merchandise you need to meet right now!',
      plus_home_05: "When you're curious about buyers' reviews",
      plus_home_06: "Today's Review",
      channel_on: 'NBOX Channel on',
      nbox_hot_item: 'The NBOX Hot Item to Watch Right Now',
    },
  },
  community: {
    input: 'Input',
    comment_place_holder: 'Leave a comment',
    review: 'Reviews',
    community_01: 'No changes made.',
  },
  cart: {
    title: 'Shopping Cart',
  },
  goods_types: {
    mps: 'MarppleShop Production',
    pbg: 'Creator Delivery',
    tpl: 'MarppleShop Delivery',
    dtg: 'Digital/E-book',
    mps_delivery: 'MarppleShop Production',
    pbg_delivery: 'Creator Delivery',
    tpl_delivery: 'MarppleShop Delivery',
    tooltip: {
      mps_title: 'MarppleShop Production Products',
      mps_description:
        'Products directly produced and shipped by MarppleShop.<br />The basic shipping fee is charged regardless of the payment amount, and additional fees may apply for remote areas.',
      pbg_title: 'Creator Delivery Products',
      pbg_description:
        'Products shipped by creators.<br />Shipping fees and delivery times may vary depending on the creator.',
      tpl_title: 'MarppleShop Delivery Products',
      tpl_description:
        'Products directly shipped by MarppleShop.<br />The basic shipping fee is charged regardless of the payment amount, and additional fees may apply for remote areas.',
    },
  },
  product_types: {
    custom: 'Order Custom',
    handmade: 'Handmade',
    pod: 'Order Made',
  },
  product_detail: {
    tab01: 'Story',
    tab02: 'Product Info',
    tab03: 'Purchase/Shipping',
    tab04: 'Reviews',
    tab05: 'Fan Letters',
    unfold_btn: 'View More',
    fold_btn: 'Close',
    left_count: '{{count}} items left',
    left_time: '{{time}} Left',
    coming_soon: 'Unopened',
    total_price: 'Total price',
    badges: {
      sold_out: 'Sold out',
      limited: 'Limited',
    },
    recommend_and_fan_letter: {
      recommend_title: 'Related Products',
    },
    purchase_info: {
      th_1: 'Business Name',
      th_2: 'Creator Name',
      th_3: 'Business Registration Number',
      th_4: 'Email',
      th_5: 'Contact',
      th_6: 'Return Shipping Cost',
      th_7: 'Return Address',
      th_8: 'Business Registration Number',
      th_9: 'Shipping Method',
      th_10: 'Delivery Area',
      th_11: 'Delivery Timeframe',
      th_12: 'Customer Service Center',
      th_13: 'Round-trip Shipping Fee',
      delivery_info: 'Shipping',
      delivery_company: 'Standard Courier({{company}})',
      delivery_desc_mps:
        'All the goods are newly manufactured in custom order and delivered.<br/>If you order now, the manufacturing process begins on <span sytle=”color:{{color}};”>{{start}}</span>, and the goods are to be shipped out before <span sytle=”color:{{color}};”>{{end}}</span>.',
      delivery_desc_tpl:
        'If you order now, the manufacturing process begins on <span style="color:{{color}};">{{start}}</span>, and the goods are to be shipped out before <span style="color:{{color}};">{{end}}</span>.',
      delivery_period_mps:
        'After the product is shipped, it can be received within 1-3 business days. However, in the case of remote or mountainous areas or when the courier service has a high volume of shipments, it may take a little longer.',
      delivery_period_tpl:
        'After the product is shipped, it can be received within 1-3 business days. However, in the case of remote or mountainous areas or when the courier service has a high volume of shipments, it may take a little longer.',
      all_country: 'Nationwide',
      delivery_faq_btn: 'View Delivery FAQ',
      exchange_info: 'Exchange / Refund',
      exchange_desc_mps:
        'All products delivered by MarppleShop are <span style="color:{{color}};">custom-made</span> based on your order, so exchange/refund due to simple change of mind are not possible. However, if you receive a defective product or if there is a shipping error, you can contact our customer service within 7 days via email, Individual Inquiry, or through our customer center for exchange or refund.',
      exchange_tel: '<a href="tel:{{tel}}">{{tel}}</a>',
      exchange_email: '<a href="mailto:{{email}}">{{email}}</a>',
      exchange_widerrufsrecht_btn: 'Quality Assurance Guidelines',
      exchange_guarantee_btn: 'Quality Warranty Criteria',
      mps_qna_btn: 'Individual Inquiry',
      qna_btn: '1:1 Inquire',
      exchange_faq_btn: 'View Exchange/Refund FAQ',
      report_info: 'Report',
      report_desc:
        'MarppleShop operates a reporting center for creators, consumers, and copyright protection.<br/>You can report products that violate internal MarppleShop regulations or are deemed to infringe on the copyrights or portrait rights of third-party works.',
      report_btn: 'Report',
      creator_info: 'Creator Info',
      dtg_info_title: 'Please make sure to check before purchasing Digital/E-book!',
      dtg_info_item_1: 'All products are in digital file format, not physical items.',
      dtg_info_item_2:
        'After completing the payment, you can download from your purchase history for 7 days.',
      dtg_info_item_3: 'You may be penalized if you use it beyond the license scope set by the creator.',
      dtg_info_item_4:
        'Due to the nature of Digital/E-book, exchanges and refunds are not possible for any reason after purchase.',
    },
    review: {
      empty_title: 'There are no reviews yet.',
      empty_title_mps: 'The chance to become a first reviewer!',
      empty_text: 'Be the first to write a review!',
      empty_text_mps: 'A heartfelt review means a lot to creators.<br/>Register your review and earn points!',
      show_more: 'View {{count}}reviews',
      option: 'Option : {{option_name}}',
      sns_review: 'SNS Review',
    },
    nbox: {
      pick_title: 'Nexon Pickup',
      pick_desc1: 'Free',
      pick_desc2: 'Available for Nexon Pickup',
    },
    max_purchase_per_user: 'Can purchase up to {{count}} per user!',
    possible_quantity: 'Can add up to {{count}} items!',
    already_possible_quantity_title: 'Purchase available per person exceeded',
    already_possible_quantity: 'You already bought or it’s in your cart',
    cta: {
      coming_soon: 'Available soon',
      not_approve: 'Available for purchase after approval.',
      sold_out: 'Sold Out',
      end_sale: 'Sales Closed',
      only_pc: 'Digital goods can only on PC.',
      purchased_dtg: 'You already bought!',
      cart: 'Cart',
      buy_now: 'Buy Now',
      buy: 'Add to Cart',
    },
    errors: {
      option_required: 'No options have been selected.<br/>Please choose an option for the product.',
      option_required_mo: 'No options have been selected.<br/>Please choose an option for the product.',
    },
    purchase_delivery: {
      title: 'Shipping Information ',
      pd01: 'If you order now, it will be shipped between <span style="color: {{color}};">{{start}}</span> and <span style="color: {{color}};">{{end}}</span>.',
      pd02: 'If you order custom-made products from Mapleshop together, they will be shipped according to the shipping date of the custom-made product.',
      pd03: 'The ordered products are expected to start shipping within 3 days. Please understand that delivery may be delayed depending on the logistics situation.',
      info: {
        '01': '단, 수령하신 상품이 불량이거나 오배송된 경우에는 30일 이내 고객센터 또는 이메일, 1:1 문의로 연락주시면 교환 및 반품 환불이 가능합니다.',
        '02': '교환/반품 신청은 고객센터 또는 이메일로 접수해주시면 택배사 반품 접수를 도와드립니다.',
        '03': '반품 양식서를 작성하셔서 상품과 함께 포장해주세요. (반품양식서 누락시 환불이 지연될 수 있습니다.)',
        '04': '타 택배사 또는 임의로 택배를 보내시면 반송될 수 있으며 분실 및 접수 누락으로 환불이 지연되거나 불가할 수 있습니다.',
        a_01: '교환/반품 요청 기간은 상품 개봉 및 훼손 없이, 배송 완료 후 7일 이내인 경우에만 환불이 가능합니다.',
        a_02: '예외로 맞춤형 주문제작 상품의 경우 단숨 변심으로 인한 주문취소/교환/반품이 어렵습니다.',
        b_01: '본 상품은 <strong>맞춤형 주문제작 상품</strong>으로, 단순 변심으로 인한 주문취소/교환/반품이 어렵습니다.',
        c_01: '본 상품은 일반 주문제작 상품으로, 교환/반품 요청 기간은 상품 개봉 및 훼손 없이 배송 완료 후 7일 이내인 경우에만 환불이 가능합니다.',
      },
      case: {
        title: '반품/교환 불가능한 경우',
        '01': '맞춤형 주문 제작 상품의 경우',
        '02': '반품요청 기간이 지난 경우',
        '03': '구매자의 책임 있는 사유로 상품 등이 훼손 또는 멸실된 경우',
        '04': '구매자의 책임 있는 사유로 포장이 훼손되어 상품 가치가 현저히 상실된 경우 (예 : 식품, 화장품, 향수류, 음반, 전장류 등)',
        '05': '구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우 (라벨 제거, 태그 제거 등)',
        '06': '상품 고지 내역과 상이, 계약 내용과 다르게 이행된 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내 둘 중 하나 경과 시 반품/교환 불가',
        '07': '복제가 가능한 상품 등의 포장을 훼손한 경우 (예 : CD/DVD/GAME/도서의 경우 포장 개봉 시)',
      },
    },
    dtg: {
      file_type: 'File Type',
      hyper_link: 'Link',
      license: 'License',
    },
    options: {
      color: 'Color',
      preview_by_device: 'Smartphone Application',
      size: 'Size',
      quantity: 'Quantity',
      device: 'Device',
      custom: 'Custom Option',
      preview: 'Preview',
      type: 'Type',
      hyper_link: 'Hyper Link',
      license: 'License',
      size_guide: 'Size Guide',
    },
    brand_delivery: 'Brand shipping',
    brand_delivery_desc:
      'This item is shipped directly from the brand.<br/>Please check the purchase information!',
    creator_delivery: 'Creator Delivery Products',
    creator_delivery_desc:
      'These are products shipped by creators. Shipping fees and delivery times may vary depending on the creator.',
    mps_delivery: 'MarppleShop Production Products',
    mps_delivery_desc:
      'These are products directly manufactured and shipped by MarppleShop. The standard shipping fee is the same regardless of the payment amount, and additional charges may apply for island and mountain areas.',
    tpl_delivery: 'MarppleShop Delivery',
    tpl_delivery_desc:
      'These are products directly shipped by MarppleShop. The standard shipping fee is the same regardless of the payment amount, and additional charges may apply for island and mountain areas.',
    total_label: 'Total <span class="dynamic-value">{{count}}</span>',
    not_approve: 'You can purchase it after sales approval.',
    sold_out_products: 'Sold Out',
    end_sale: 'Sold Out',
    only_pc: 'Only PC',
    purchased_dtg: 'Already Bought it!',
    cart: 'Add to Cart',
    buy: 'Buy',
    noti: {
      left: '{{left}} Left!',
      end_of_sale: '{{start_at}} ~ {{end_at}}',
      until_close:
        'To the end&nbsp;<span class="remain_time" data-start_at="{{start_at}}" data-end_at="{{end_at}}">{{remain_time}}</span>',
      until_open:
        'To the open&nbsp;<span class="remain_time" data-start_at="{{start_at}}" data-end_at="{{end_at}}">{{remain_time}}</span>',
    },
    delivery_info: {
      info_label: 'Delivery',
      start_date_label: 'Departure Date',
      expect:
        'If you order now, the delivery will begin\nbetween&nbsp;<span class="pd-guide__start-end-strong" style="color: {{color}};">{{start}} ~ {{end}}&nbsp;</span>',
      parcel: 'Regular courier',
      message1: "We'll pack it with special delivery care.<br />Please wait with excitement!",
      free_ship: 'Free shipping',
      base_price: 'Shipping Cost ${{ price }}',
      addi_price: 'Additional Cost',
      label_1: 'Shipping Method',
      label_2: 'Delivery Area',
      label_3: 'Shipping Cost',
      label_4: 'Delivery Timeframe',
      label_5: 'Shipping Cost',
      label_6: 'Additional Cost',
      desc_1:
        'Receive the product within 1-3 business days after shipping. However, delivery to remote or island areas, or during high volume periods for the courier service, may take a bit longer.\n',
      message2:
        "High demand may delay production and shipping.{{- br}}We'll notify you via text if delayed\n",
    },
    best_seller_title: 'Best Seller',
    best_seller_subtitle: 'Best Products',
    link_delivery: 'Delivery FAQ',
    link_chat: '1:1 Inquire',
    link_change: 'Exchange/Refund FAQ',
    option_modal_title: 'Option',
    quality_modal: {
      p1: 'This product is manufactured under strict quality control and has passed appearance, size, and physical property inspections.',
      p2: 'To extend the life of the product, please follow the care instructions and washing methods attached to the product. If there is any quality issue, please contact customer service.\n',
      cs_title: 'CS',
      email_title: 'E-mail',
    },
    retraction_modal: {
      p1: 'Exchange/return is not possible if the product has been worn or used despite signs of wear, washing, odor, contamination, arbitrary repair, or if the product is damaged or defective.',
      p2: 'Restrictions on Cancellation<br />(Article 17, Paragraph 2, Subparagraph 6 and Article 21 of the Enforcement Decree)',
      li1: 'Detailed sizes may vary by 1-3cm depending on the measurement method and position. Discrepancies between the stated detailed size and actual measurements (1-3cm) cannot be processed as defects and cannot be grounds for exchange or refund.',
      li2: 'The products sold are supplied through sampling from each brand and wholesaler, so detailed sizes may differ from specific brands or products you own. Please be sure to check the detailed size when making an actual purchase.',
      li3: 'Size measurements should be taken from end to end with the product laid flat on the floor, and stretchy materials should be measured as they lie without pulling. Please understand that returns and exchanges due to incorrect measurements outside the error range are not possible.',
    },
    private: {
      title: 'The item has been discontinued or suspended.',
      description: 'This product is currently discontinued<br/>or deleted and cannot be viewed.',
      btn: 'View other products',
    },
    tab02_ness: 'Product Information',
    tab03_ness: 'Purchase/Shipping',
    ness: {
      not_available_description:
        '선택하신 상품은 현재 판매가 종료되거나,<br />삭제되어 확인하실 수 없습니다.',
    },
  },
  review: {
    comment_header: 'Please leave a review for the product',
    write_review: 'Write Review',
    comment_title: 'Review Contents',
    placeholder: 'Please write at least 15 characters.',
    desc1: 'All reviews must include at least one image.',
    desc2:
      'Reviews unrelated to the product, containing profanity, or violating the review policy may be flagged and warned without notice.',
    sns_share: 'SNS',
    agree: 'Consent to the use of review.',
    remove: 'Delete Review',
    remove_desc: 'Would you like to delete your review?',
    remove_comment: 'Delete Comments',
    remove_comment_desc: 'Would you like to delete your comment?',
    more: 'More',
    desc3: 'Image formats : jpeg, png, gif / Limit 5MB',
    thankyou_title: 'Review Completed',
    thankyou_desc: 'Thank you for writing review.',
  },
  creator: {
    sub_title: 'Creator',
    sort: {
      최신순: 'Recently',
      인기순: 'Best',
    },
    header_title: 'Creator',
    rank: {
      top_10_ranking: '{{interval}} \nranking',
      top_10_text: 'top 10',
    },
  },
  limit_product: {
    limit_product_01: 'Limited Edition',
  },
  ness: {
    mypage: {
      main_01: 'Products being ordered/shipped',
      main_02: 'Reviews I wrote',
      main_03: 'Products I liked',
      main_01_mobile: 'Order/Shipping',
      main_02_mobile: 'Reviews',
      main_03_mobile: 'Likes',
      main_04: 'My Store',
      main_05: 'Seller Studio',
      main_06: 'Plus Admin',
      main_07: 'Account Settings',
      main_08: 'Logout',
      main_09: 'Purchase Details',
      main_10: 'My Reviews',
      main_11: 'Likes',
      main_12: '1:1 Inquire',
      main_13: 'Report receipt Service',
      main_14: 'Notes on the use of site',
      like_01: '<span>My liked products <span class="count">{{count}}</span></span>',
      like_02: '<span>My liked store <span class="count">{{count}}</span></span>',
      like_01_mobile: '<span>Liked products <span class="count">{{count}}</span></span>',
      like_02_mobile: '<span>Liked store <span class="count">{{count}}</span></span>',
      like_03: 'If you find a product you like, please click the like button.',
      like_04: 'If you find a store you like, please click the like button.',
      review_01: 'No reviews have been written yet.',
      nexon_account_info: 'NEXON Account',
      nexon_account_modify: 'Change NEXON information',
      nexon_account_modify_mo: 'Change NEXON information',
      nexon_agree_info: '* Subscription settings can be checked at [Nexon.com > My Information].',
    },
    order: {
      order_01: 'NESS Delivery',
      order_02: 'Creator Delivery',
      revise_shipping: 'Change Shipping Address',
      order_custom: 'Order-made Delivery',
      order_01_add: 'NEXON ESSENTIAL Remote Area Shipping',
      order_02_add: 'Seller Remote Area Shipping',
      order_custom_add: 'Custom Product Remote Area Shipping',
    },
    home: {
      home_01: 'New Arrivals',
      home_02: 'Best Products',
      home_03: 'View {{-count}} More Special Sale Items',
      home_04: '{{brand}} Branded Content',
      home_05: 'Reviews',
    },
    product: {
      only_limited: 'View Special Sales Only',
      only_limited_mo: 'Special Sales Only',
      only_stock_available: 'Exclude Sold Out Items',
      product_03: 'New Products',
      product_04: 'New Arrivals',
      product_05: 'Special Sale Items',
      product_06: 'Special Offer',
      product_07: 'Popular Products',
      product_08: 'Best Seller',
      product_09: 'Empty Product List',
      product_10: 'No products match your criteria.',
      product_11: 'Coming Soon',
      custom: 'Custom-made Products',
      only_stock_available_mo: 'Exclude Sold Out',
    },
    product_sort: {
      default: 'Default',
      popular: 'By Popularity',
      recent: 'By Recent Upload',
      most_liked: 'By Most Liked',
      price_high_to_low: 'Price: High to Low',
      price_low_to_high: 'Price: Low to High',
    },
    product_badge: {
      sale: 'Sale',
      new: 'New',
      collection: 'Collection',
      ranking: 'Ranking',
      quantity_limited: '{{count}} Left',
      left: 'Left',
      day_one: '{{count}} Day',
      special: 'Special',
      offer: 'Offer',
      day_other: '{{count}} Days',
      hour_one: '{{count}} Hour',
      hour_other: '{{count}} Hours',
      minute_one: '{{count}} Minute',
      minute_other: '{{count}} Minutes',
    },
    review: {
      count_one: 'Review',
      count_other: 'Reviews',
    },
    footer: {
      company_name: 'NEXON KOREA Corporation',
      customer_center: 'Customer Center',
      ceo: 'CEO',
      ceo_name: '강대현·김정욱',
      address: 'Address',
      address_info: '경기도 성남시 분당구 판교로 256번길 7',
      company_registration_info: 'Business Registration Number',
      company_registration_number: '220-87-17483',
      footer1: 'Terms of Service',
      footer2: 'Privacy Policy',
      footer3: 'Service Guide',
      footer4: 'Phone Number',
      footer5: 'Weekdays',
      footer6: 'Lunch Break',
      footer7: 'Closed on Holidays and Weekends',
      footer8: 'Business Information',
      footer9: 'Business Hours',
      footer10: 'Email',
      footer11:
        'For some products sold on NEXON ESSENTIAL, NEXON KOREA Corporation acts as an e-commerce intermediary, not as a direct seller, and is not responsible for products, product information, and transactions registered by sellers.',
      footer12: 'Hosting Service Provider',
      footer13: 'Marpple Corporation',
      address_info_part1: 'Bundang-gu, Seongnam-si, Gyeonggi-do&nbsp;',
      address_info_part2: '7, Pangyo-ro 256beon-gil',
      footer14: '10F, 75-24, Gasan digital 1-ro, Geumcheon-gu, Seoul',
      footer15:
        'For secure transactions, you can use the Purchase Safety Service by KG Inicis when paying with cash or other methods at our mall.',
      company: 'Company Name',
    },
    plus_admin: {
      pa_001: 'Store Settings ',
      pa_002: 'Apply the site reflecting brand identity, including colors, logo, etc',
      pa_003: 'Store Information',
      pa_004: 'Store Color ',
      pa_005: "The site's logo background will be reflected in the header, etc",
      pa_006: 'Red',
      pa_007: 'Orange',
      pa_008: 'Yellow',
      pa_009: 'Deep Green',
      pa_009_01: 'Green',
      pa_010: 'Sky',
      pa_011: 'Magenta',
      pa_012: 'Gold',
      pa_013: 'White',
      pa_014: 'Black',
      pa_015: 'Game Title',
      pa_016: 'Store Name',
      pa_017: 'Store Introduction ',
      pa_018: 'Store Logo',
      pa_019: 'Please upload a square ratio image file.<br/>(Image upload: PNG format supported / Max 3MB)',
      pa_020: 'Apply',
      pa_021: 'Delete',
      pa_022: 'Store Cover',
      pa_023: 'PC Image',
      pa_024: 'Size 3840 x 1280px',
      pa_025: 'JPG, PNG formats supported',
      pa_026: 'Max 8MB',
      pa_027: 'Please register <br/>the PC store cover image.',
      pa_028: 'Mobile image',
      pa_029: 'Please register the mobile store cover image.',
      pa_030: 'Size 1050 x 1960px',
      pa_031: 'Verify Immediately',
      pa_032: 'Apply',
      pa_033: 'Try Registering a Promotional Banner.',
      pa_034: 'Modify Main Banner',
      pa_035: 'Basic settings',
      pa_036: 'Image banner URL address',
      pa_037: 'Video thumbnail image',
      pa_038: 'Upload video thumbnail.',
      pa_039: 'Thumbnail image: Size 1920 x 1080px / JPG, PNG formats accepted / Up to 3MB.',
      pa_040: 'Upload video thumbnail.',
      pa_041: 'Apply',
      pa_042: 'Please enter the YouTube URL.',
      pa_043: 'Please upload the image or video file to be used as a promotional banner.',
      pa_044: 'Image',
      pa_045: 'Size 1920px x 1080px  \nJPG, PNG accepted \nUp to 3MB',
      pa_046: 'Video',
      pa_047: '최소 사이즈 710px x 400px<span></span>60초 이하<span></span> ',
      pa_047_1: 'MP4 또는 유튜브 URL 등록 가능<span></span>최대 15MB',
      pa_048: 'Set Public Period',
      pa_049: 'File Type is Incorrect',
      pa_050: 'The video Resolution Size is Smaller than the Minimum Size',
      pa_051: 'The video duration exceeds the max length',
      pa_052: 'The video file size exceeds the max size',
      pa_054: 'Video upload error',
      pa_055: 'Failed To Register Promotion Banner',
      pa_056: 'Video banners require thumbnails.',
      pa_057: 'Exceeded max number of banner publications',
      pa_057_01: 'Exceeded max number of video publications',
      pa_058: 'The max number of publications has been exceeded. You can publish up to 5 items',
      pa_058_01: 'The max number of publications has been exceeded. You can publish up to 1 items',
      pa_059:
        'The max number of publications has been exceeded. The publication status of the banner will be set to private',
      pa_059_01:
        'The max number of publications has been exceeded. The publication status of the video will be set to private.',
      pa_060: 'You can change the order by dragging and dropping',
      pa_061: 'Video Banner Title',
      pa_062: 'Default Settings',
      pa_063: 'Video URL Address',
      pa_064: 'Video Banner Management',
      pa_065: 'All Video Banners',
      pa_066:
        'Create and manage video banners to display on the game store main page. You can publish up to 1 item',
      pa_067: 'Register a video banner for display on the home screen',
      pa_068: 'Manage Video Banners',
      pa_069: 'Register Video Banner',
      pa_061_01: 'Up to 37 characters allowed',
      pa_070: 'Edit Video Banner',
      pa_071:
        'Promotion banners can be displayed up to 5 on the main page.\nChange the order in Promotion Banner Management > Change Main Sort tab',
      pa_071_01:
        'Video banners can be displayed up to 5 on the main page.\nChange the order in Video Banner Management > Change Main Sort tab.',
      pa_072: 'Meta Tag Settings',
      pa_073: 'OpenGraph Title',
      pa_074: 'OpenGraph Description',
      pa_075: 'OpenGraph Image',
      pa_076: 'Recommended size (1200px width * 600px height)',
      pa_077: 'Apply',
      pa_078: 'Corporate official website URL',
      pa_079: 'Facebook URL',
      pa_080: 'Instagram URL',
      pa_081: 'YouTube URL',
      pa_082: 'Twitter URL',
      pa_016_01: 'Store Name (Category)',
    },
    checkout: {
      receipt: {
        receipt_01: 'Account number has been copied.',
      },
    },
    confirm: {
      ok: 'Yes',
      cancel: 'No',
    },
    login: {
      login_01: 'NEXON ESSENTIAL Sign Up',
      login_02: 'To join NEXON ESSENTIAL,<br/>please register your NEXON account email.',
      login_02_01:
        'We cannot verify your NEXON account email information.<br/>Registration is possible after registering an email.',
      login_03: 'Register Email',
      login_04: 'Please register an email address to your NEXON account.',
      login_05: 'Identity Verification',
      login_06: 'Please complete identity verification for your NEXON account.',
      login_07: 'Age Verification (14+)',
      login_08: 'Users under 14 require guardian verification.',
      login_09: 'Go',
      login_10: 'Email',
      login_11: 'Nickname',
      login_12: 'Mobile Phone Number',
      login_13: 'Agree to All Terms',
      login_14: 'NEXON ESSENTIAL Terms of Service Agreement (Required)',
      login_15: 'Privacy Policy Agreement (Required)',
      login_16: 'Receive Useful News about Games and Services (Optional)',
      login_17: 'View',
      login_18: 'Your NEXON login session has expired.<br/>Please try again.',
      login_19: 'Login was not completed successfully.<br/>Please try again.',
      login_20: 'NEXON Login',
      require: {
        title: 'Please log in to purchase products.',
        body: 'Products can only be purchased by NEXON ESSENTIAL members.',
      },
      login_21: 'Collection of Personal Information from Children Under 14',
      login_22: 'Legal Representative Mobile Phone Verification',
      login_23:
        "NEXON KOREA Corporation is obtaining guardian consent to collect personal information from children under 14 as follows.<br/>Guardians, please provide consent after fully understanding the details of how your child's personal information will be processed.",
      login_24: "Consent to Collection and Use of Child's Personal Information",
      login_25: "Consent to Collection and Use of Guardian's Personal Information",
      login_26: 'To purchase products,<br/>please register your NEXON account email.',
      login_27:
        'We cannot verify your NEXON account email information.<br/>Purchase is possible after registering an email.',
      login_28: 'Try Again with Another Account',
      login_29:
        'You can receive helpful information such as updates, pre-registrations, and event participation for all games and services provided by NEXON KOREA Corporation.<div style="padding-top: 4px">You can check your subscription status at [NEXON.com > My Information].</div>',
      login_30: 'From now on, you will receive<br/>useful news about games and services.',
      login_31: '{{date}} Provided by NEXON KOREA Corporation',
      login_32:
        "During the mobile phone verification process, you may receive an authentication request from 'Marpple Corporation'.<br/>'Marpple Corporation' is an official operating partner of NEXON ESSENTIAL, so you can feel safe.",
      login_32_mobile:
        "During the mobile phone verification process, you may receive an authentication request from 'Marpple Corporation'. 'Marpple Corporation' is an official operating partner of NEXON ESSENTIAL, so you can feel safe.",
    },
    my_page: {
      is_hidden_user: 'Leave NEXON ESSENTIAL',
      change_profile: 'Profile image has been changed.',
      delete_profile: 'Profile image has been deleted.',
      marketing_agree_title: 'Agree to receive promotional information.',
      marketing_agree_body: '{{date_time}} You have agreed to receive promotional information.',
      marketing_disagree_title: 'Withdraw consent to receive promotional information',
      marketing_disagree_body: '{{date_time}} You have unsubscribed from receiving promotional information.',
    },
    editorial: {
      related: 'Related Editorial',
    },
    common: {
      see_more: 'View More',
      close: 'Close',
    },
    privacy: {
      privacy_child: "Consent to Collection and Use of Child's Personal Information",
      privacy_guardian: "Consent to collect and use guardian's personal information.",
    },
    'my-page': {
      main_09: '',
    },
    up_item: {
      logo: '',
    },
    studio: {
      product_guide: {
        title: 'What are MarppleShop Production Products and Creator Delivery Products?',
        about_pod: 'MarppleShop Production Products',
      },
    },
  },
  '로그인 후 이용해 주세요.': 'Please log in to use this service.',
  collection_category: {
    ALL: 'All',
    EXCLUSIVE: 'Exclusive',
    FUNDING: 'Funding',
    All: 'All',
  },
  collection: {
    coll_1_1: 'Description',
    mo_header: 'Collection',
  },
  '개인 정보 수집 및 이용 동의': 'Consent to Collection and Use of Personal Information',
  customer_order: {
    receipt_info: 'View Receipt',
    receipt: {
      card: 'Credit Receipt',
      cash: 'Receipt',
      purchase: 'Purchase Receipt',
      id: 'Purchase Number',
      paid_at: 'Transaction Date',
      provider: 'Payment Agency',
      orderer: 'Buyer Name',
      products: 'Product Name',
      price: 'Price',
      pdf: 'Save as PDF',
      print: 'Print',
      total_price_t: 'Approved Price',
      cancel_price_t: 'Cencelled Price',
      up_c_id: 'Product Number',
      supply_price_t: 'Supply Price',
      vat_price_t: 'VAT',
      result_price_t: 'Total',
      'change-warn':
        'Payment information has been modified.<br>Please contact customer service for verification.',
      detail: {
        card_title: 'Card Receipt (Sales Slip)',
        cash_title: 'Receipt',
        card_name: 'Card Name',
        apply_num: 'Approval Number',
        paid_at: 'Payment Date',
        card_num: 'Card Number',
        card_info: 'Card Company',
        seller_info: 'Seller Info',
        seller_name: 'Business Name',
        seller_ceo: 'Representative Name',
        seller_num: 'Business Registration Number',
        seller_tel: 'Number',
        seller_address: 'Address',
        provider_info: 'Merchant Info',
        provider_name: 'Merchant Name',
        provider_tel: 'Merchant Number',
        provider_address: 'Address',
        cancel_info: 'This payment has been cancelled.',
        card_quota: 'Transcation Type/Installment',
        product_classification: 'Section',
      },
      canceled: 'Cancelled Receipt',
      header_title: 'Receipt History',
      paid_at_title: 'Order Date',
      purchase_info: 'Purchase Info',
      cash_cancel: '',
      cannot_print_mo: 'Receipt printing is available on PC',
    },
    contents: {
      list_description: 'Something you might like 💘',
    },
    receipt_button: '',
  },
  error: {
    desc404:
      'The address of the page you are trying to find may have been entered incorrectly,<br/>or the page may be inaccessible due to changes or deletion of the address.<br/>Please verify that the address you entered is correct.',
    desc500:
      'We apologize for the inconvenience in using our service.<br/>There was a temporary issue with the server.<br/>Please try again in a moment.',
  },
  tpl_faq: {
    group_1_label: 'Order/Shipping',
    group_1_q1: 'How long does it take to receive products after ordering?',
    group_1_a1:
      'The ordered products will begin shipping within 3 days. Please understand that delivery may be delayed depending on logistics conditions.',
    group_1_q2: 'How can I check my order status?',
    group_1_a2:
      'You can check your order status and shipping schedule in Login > My Page > Purchase History.<br/><br/>The progress of your ordered products is as follows:<br/>[Preparing Production/Preparing Product]: This is the stage where payment has been completed and we are preparing the product.<br/>[In Production]: This is the stage where your ordered product is being produced.<br/>[Preparing for Shipping]: Production is complete, and we are inspecting and packaging the product.<br/>[Shipping]: Your ordered product has been shipped and transferred to the courier company. The tracking number will be sent via text message. You can check the shipping status by tracking the invoice number from the day after shipping.<br/>[Delivery Complete]: Delivery has been completed.',
    group_1_q3: 'Can non-members place orders?',
    group_1_a3:
      'NEXON ESSENTIAL orders are only available to NEXON members.<br/>Please sign up as a NEXON member before using the service. As a NEXON member, you can not only place orders at NEXON ESSENTIAL but also receive various events and benefits.',
    group_2_label: 'Exchange/Refund',
    group_2_q1: 'Can I cancel my order?',
    group_2_a1:
      "Up to a certain stage, members can directly cancel orders from My Page > Purchase History > Details.<br/>ㆍ <b>[Order Received / Preparing Production]</b>: Members can directly cancel orders until this stage.<br/>ㆍ <b>[In Production / Preparing Product]</b>: From this stage, members cannot directly cancel orders. Please request cancellation through Customer Service or email inquiry.<br/>ㆍ As an exception, custom-made products are difficult to cancel, exchange, or return due to a simple change of mind.<br/>ㆍ You can find information about order cancellation in the FAQ's Cancellation/Refund section.<br/>※ NEXON ESSENTIAL produces only what is used, preventing resource waste through efficient production and environmental consideration. Please make your purchase carefully.",
    group_2_q2: 'Can I exchange or refund products after receiving them?',
    group_2_a2:
      "Exchange/return requests are only possible within 7 days after delivery completion, without opening or damaging the product.<br />\n     As an exception, custom-made products are difficult to cancel/exchange/return due to a simple change of mind.<br />\n     However, if the product you received is defective or incorrectly shipped, you can contact the Customer Service or email, or 1:1 inquiry within 30 days for exchange, return, or refund.<br />\n     For exchange/return requests, please contact the Customer Service or email, and we will help you with the courier return registration.<br />\n     Please fill out the return form and package it with the product. (Refunds may be delayed if the return form is missing.) If you send the package through other courier services or without proper registration, it may be returned, or the refund may be delayed or not possible due to loss or missing registration.<br /><br />\n     \n     Cases where returns/exchanges are not possible:<br />\n     ㆍ Custom-made products<br />\n     ㆍ When the return request period has expired<br />\n     ㆍ When the product is damaged or destroyed due to reasons attributable to the buyer<br />\n     ㆍ When the packaging is damaged due to reasons attributable to the buyer, significantly losing the product's value (e.g., food, cosmetics, perfumes, records, electronics, etc.)<br />\n     ㆍ When the product's value is significantly reduced by the buyer's use or partial consumption (e.g., label removal, tag removal, etc.)<br />\n     ㆍ When the product differs from the notification details or is fulfilled differently from the contract content, returns/exchanges are not possible after either 3 months from receiving the product or 30 days from knowing the fact that differs from the display/advertisement<br />\n     ㆍ When the packaging of reproducible products is damaged (e.g., when opening the packaging of CD/DVD/GAME/books)",
  },
  faq: {
    group_1_label: 'Order/Shipping',
    group_1_q1: 'How long does it take to receive products after ordering?',
    group_1_a1:
      'This product is a made-to-order item. Made-to-order products are operated in a way that collects orders for one week and produces and ships them the following week. Because of this, it takes some time for products to be shipped after ordering, and we provide individual guidance to customers depending on the shipping status. Please understand that it may take at least one week or more from order to product receipt.',
    group_1_q2: 'How can I check my order status?',
    group_1_a2:
      'You can check your order status and shipping schedule in Login > My Page > Purchase History.<br/><br/>The progress of your ordered products is as follows:<br/>[Preparing Production/Preparing Product]: This is the stage where payment has been completed and we are preparing the product.<br/>[In Production]: This is the stage where your ordered product is being produced.<br/>[Preparing for Shipping]: Production is complete, and we are inspecting and packaging the product.<br/>[Shipping]: Your ordered product has been shipped and transferred to the courier company. The tracking number will be sent via text message. You can check the shipping status by tracking the invoice number from the day after shipping.<br/>[Delivery Complete]: Delivery has been completed.',
    group_1_q3: 'Can non-members place orders?',
    group_1_a3:
      'NEXON ESSENTIAL orders are only available to NEXON members.<br/>Please sign up as a NEXON member before using the service. As a NEXON member, you can not only place orders at NEXON ESSENTIAL but also receive various events and benefits.',
    group_2_label: 'Exchange/Refund',
    group_2_q1: 'Can I cancel my order?',
    group_2_a1:
      "Up to a certain stage, members can directly cancel orders from My Page > Purchase History > Details.<br/>ㆍ [Order Received / Preparing Production]: Members can directly cancel orders until this stage.<br/>ㆍ [In Production / Preparing Product]: From this stage, members cannot directly cancel orders. Please request cancellation through Customer Service or email inquiry.<br/>ㆍ As an exception, custom-made products are difficult to cancel, exchange, or return due to a simple change of mind.<br/>ㆍ You can find information about order cancellation in the FAQ's Cancellation/Refund section.<br/>※ NEXON ESSENTIAL produces only what is used, preventing resource waste through efficient production and environmental consideration. Please make your purchase carefully.",
    group_2_q2: 'Can I exchange or refund products after receiving them?',
    group_2_a2:
      "Exchange/return requests are only possible within 7 days after delivery completion, without opening or damaging the product.<br />\n      As an exception, custom-made products are difficult to cancel/exchange/return due to a simple change of mind.<br />\n      However, if the product you received is defective or incorrectly shipped, you can contact the Customer Service or email, or 1:1 inquiry within 30 days for exchange, return, or refund.<br />\n      For exchange/return requests, please contact the Customer Service or email, and we will help you with the courier return registration.<br />\n      Please fill out the return form and package it with the product. (Refunds may be delayed if the return form is missing.) If you send the package through other courier services or without proper registration, it may be returned, or the refund may be delayed or not possible due to loss or missing registration.<br /><br />\n      \n      Cases where returns/exchanges are not possible:<br />\n      ㆍ Custom-made products<br />\n      ㆍ When the return request period has expired<br />\n      ㆍ When the product is damaged or destroyed due to reasons attributable to the buyer<br />\n      ㆍ When the packaging is damaged due to reasons attributable to the buyer, significantly losing the product's value (e.g., food, cosmetics, perfumes, records, electronics, etc.)<br />\n      ㆍ When the product's value is significantly reduced by the buyer's use or partial consumption (e.g., label removal, tag removal, etc.)<br />\n      ㆍ When the product differs from the notification details or is fulfilled differently from the contract content, returns/exchanges are not possible after either 3 months from receiving the product or 30 days from knowing the fact that differs from the display/advertisement<br />\n      ㆍ When the packaging of reproducible products is damaged (e.g., when opening the packaging of CD/DVD/GAME/books)",
  },
  mps2: {
    common: {
      price: '${{price}}',
      word_length: '{{length}}chars',
      reset: 'Reset',
      remove_all: 'Delete all',
      error_title: 'An error occurred',
      error_message: 'An error has occurred. Please try again later.',
      agree: 'Agree',
      disagree: 'Diagree',
      confirm: 'OK',
      cancel: 'Cancel',
      start: 'start',
      close: 'close',
      see_more: 'see more',
      leave: 'Exit',
      delete: 'Delete',
      update: 'Update',
      go_marppleshop: 'Go to MarppleShop',
      example: 'ex',
      category: {
        level_1: {
          goods: 'Goods',
          ebook: 'E-Book',
          brand_deal: 'Brand deal',
          handmade: 'Handmade',
        },
      },
    },
    footer: {
      마플코퍼레이션: 'Marpple Corporation',
      '마플샵 크리에이터': 'MarppleShop Creator',
      '마플샵 플러스': 'MarppleShop Plus',
      '마플샵 팝업스토어': 'Online Pop-up',
      '오프라인 팝업스토어': 'Offline Pop-up',
      '온라인 팝업스토어': 'Online Pop-up',
      '브랜드 커머스': 'Brand Commerce',
      '유튜브 쇼핑': 'Youtube Shopping',
      '핸드메이드 크리에이터': 'Handmade Creator',
      '커머스 크리에이터': 'Commerce Creator',
      '굿즈 파트너스': 'Goods Partner',
      고객센터: 'Customer Center',
      신고센터: 'Reporting Center',
      이용약관: 'Terms of Service',
      개인정보처리방침: 'Privacy Policy',
      privacy_charge: 'Privacy Protection Officer',
      privacy_charge_name: '유인동',
      customer_center_info: 'On weekdays 10:00 ~ 18:00',
      inicis_info:
        'When paying with cash through KG Inicis, you can use the Purchase Safety Service that our company has subscribed to.',
      inicis_button: 'Verify KG Inicis Membership',
      notice:
        'For Creator-shipped products and digital/e-book products, Mapple Corporation acts solely as an intermediary for communication sales and is not a party to the actual transaction. Responsibility for order, delivery, and refund lies with each individual seller.',
      business_info: 'Business Information',
      '마플샵 오프라인 팝업스토어': 'Offline Pop-up',
      '마플샵 브랜드 커머스': 'Brand Commerce',
      '마플샵 X 유튜브 쇼핑': 'MarppleShop X Youtube',
      terms_paid_service: 'Terms of Integrated Paid Service',
      customer_support: 'Customer Support',
      faq: 'FAQ',
      inquiry: '1:1 Inquiry',
    },
    product: {
      title: 'Products',
      sub_title: 'Introducing the products at MarppleShop!',
      limited: 'LIMITED',
      best: 'BEST',
      all_products: 'All Products',
      all: 'ALL',
      only_stock_available: 'Exclude Sold Out',
      product_01: 'Time to Buy {{count}} Special Items!',
      product_02: 'These kinds of goods are trending these days😎',
      total: 'Total of',
      count: 'products',
      price: 'Price',
      badge: {
        sold_out: 'Sold out',
        limited: 'Limited',
        closed: 'Close',
        nft: 'NFT',
        stock_left: '{{stock}} Left',
        upcoming: 'Upcoming',
        period_limited_second: '{{second}} Sec',
        period_limited_minute: '{{minute}} Min',
        period_limited_hour: '{{hour}} Hour',
        period_limited_day: '{{day}} Day',
        membership: 'Membership',
        trending: 'Trending',
        popular: 'Popular',
        brand_deal: 'Brand Deal',
        funding: 'Funding',
      },
      tag: {
        sold_out: 'Out of Stock',
        period_limited_day: '{{day}}day Left',
        period_limited: '{{time}} Left',
        quantity_limited: '{{stock}} Left',
        upcoming_soon: 'Coming Soon',
        upcoming_min: '{{minute}}minute until Open',
        upcoming_hour: '{{hour}}hour until Open',
        upcoming_day: '{{day}}day until Open',
        upcoming: 'Upcoming',
        realtime: 'Sold {{time}} ago!',
        realtime_compact: 'Sold {{time}} ago',
      },
      sort: {
        popular: 'Best',
        newest: 'Recently',
        price_high_to_low: 'Highest Price',
        price_low_to_high: 'Lowest Price',
        many_reviews: 'Reviews',
        featured: 'Recommend',
      },
      filter: {
        title: 'Product Filter',
        is_limited: 'Limited Edition Only',
        is_limited_short: 'Limited Only',
        without_sold_out: 'Exclude Sold Out',
        without_sold_out_short: 'Excludes SO',
        confirm: 'View Products',
        info: 'Product Information',
        style: 'Style',
      },
      empty: {
        shop_title: 'No Products Matching your Request.',
        shop_body: 'Try Searching for Products with Different Criteria!',
        plus_shop_body: '{{name}} is preparing a product!',
        creator_title: 'Goods are under processing',
        creator_body:
          'How about exploring the various products on MarppleShop<br />while the creator prepares the goods?',
        creator_footer: 'Find More Products',
        title: 'No Products Matching your Request.',
        description: 'Try Searching for Products with Different Criteria.',
      },
      recommend: 'Recommended',
      weekly_banner_title: 'Weekly Best TOP 100',
      weekly_banner_desc: 'Find the Most Popular Products This Week!',
      monthly_banner_title: 'Monthly Best TOP 100',
      monthly_banner_desc: 'Find  the Most Popular Products of This Month',
    },
    recently_sold: {
      sold_now: 'Sold Now',
      title: 'Sold Now',
      sub_title: 'Trending Products Selling Right Now!',
      desc: 'Check out\ntrending items\njust sold!',
    },
    creator: {
      creator_01: 'Creator',
      creator_02: 'Here to steal your heart',
      plus: {
        description: 'Official MD that your own interest',
        tooltip:
          "MarppleShop Plus: \nYour <b><u>All-in-One IP Commerce Solution.</u></b> \nFrom Platform Construction to Product Delivery, \nWe've Got You Covered!",
        tooltip_link: 'MarppleShop Plus Apply',
        see_more: 'All MarppleShop Plus',
        filter: {
          recommendation: 'Recommend',
          new: 'Recently',
          popular: 'Best',
          like: 'Likes',
          review: 'Reviews',
        },
      },
      ranking: {
        header_title: 'Creator Ranking',
        page_title: 'Creator Best Ranking',
        month: 'MMM. yyyy',
        week: 'Week {{week}}, {{year_month}}',
        period: '{{date}}',
        empty_title: 'The Creator Delivery Products are all sold out!',
        empty_desc: 'Cheer up your favorite creator and look out<br/>for newly released creator products!',
        empty_btn: 'Cheer up Creator',
      },
      txt1: 'Creator Introduction',
      description_empty: 'The creator is preparing an introduction.',
      view: {
        description: 'Stories Straight from the Creators',
      },
      all: {
        description: 'Every Creator in the World Is Here!',
        see_more: 'More',
      },
      empty_title: 'The creators are getting ready to open!',
      see_more: 'More',
      share: "Check out {{name}}'s exclusive goods at MarppleShop.",
    },
    modal: {
      취소: 'Cancel',
      확인: 'OK',
      저장: 'Save',
    },
    review: {
      title: 'Review',
      thanktyou_title: 'Your review has been successfully submitted.',
      thanktyou_desc: "You can view the review you've written in My Page > My Reviews.",
      page_title: 'Photo Reviews',
      page_sub_title: 'MaprpleShop Honest Reviews',
      page_sub_title__plus: "When you're curious about fans' stories",
      option: 'Option',
      write_place_holder:
        'When registering a review supporting the creator, up to 300 points will be credited upon review. Up to {{order_point}}points will also be provided in support funds for creator activities',
      delete: 'delete',
      sns_review: 'SNS Review',
      comment_count: 'Comments&nbsp;<span class="article-detail-comments__count">{{count}}</span>',
      empty_title: 'The chance to become a first reviewer!',
      empty_title_desc:
        'A heartfelt review means a lot to creators.<br />Register your review and earn points!',
    },
    breadcrumbs: {
      home: 'Home',
      creator_ranking: 'Creator Ranking',
      product_ranking: 'Product Ranking',
      detail: 'Details',
    },
    main: {
      quick_menus: {
        creator_apply: 'Creator Application',
        goods_partner: 'Apply for Goods Partners',
        fee_0: 'Handmade Commission 0%',
        weekly_ranking: 'Weekly Creator Rankings',
        realtime_review: 'Real-time product reviews',
        //
        fall_base_ball: 'Fall baseball',
        domiworld: 'Domi World',
        how_to_record: 'Daily recording tips',
        september_hot: 'September Hot People Association',
        book_season: 'Season for reading',
        attention_graduate_student: 'Attention graduate students',

        treasure_shop: 'Treasure shop',

        order_now_cool: 'Order now and wear when its cool',
        chuseok_nagging: 'Chuseok nagging item',

        trust_tshirt: 'In T-shirt we trust',
        love_potery: 'Fall in love with poetry',
        shampoo_picture: 'I can smell shampoo in this picture',

        say_nothing: 'Turn words into merch',
        room_change: 'Handmade home decor',
        dajai_yusanmu: 'No Longer Human, its all good',

        help_marppleshop: 'Join Marppleshop Mate',
        //
        popup_store: 'MarppleShop Popup Store',
        popular: 'Best Creators',
        best_ranking: 'Best Ranking',
        photo_review: 'Photo Review',
        plus_apply: 'MarppleShop Plus Apply',
        youtube: 'Youtube Shopping X MarppleShop',
        CCC: 'Creator Club',
        popup_store_mo: 'Online Pop-up',
        popular_mo: 'Best Creators',
        best_ranking_mo: 'Best Ranking',
        creator_apply_mo: 'Apply for Creator',
        photo_review_mo: 'Photo Review',
        plus_apply_mo: 'MarppleShop Plus',
        youtube_mo: 'Youtube Shopping',
        CCC_mo: 'Creator Club',
        curation: 'Curation',
        realtime: 'Sold Now',
        product_ranking: 'Trending Ranking',
        limited: 'Limited Edition',
        funding_apply: 'Apply for MarppleShop Funding',
        product_curation: 'Curation',
        handmade_creator: 'Handmade',
        online_popup_store: 'Online Pop-up',
      },
      creator_ranking: {
        title: 'Real Time Creator Ranking',
        title_mobile: 'Real Time Creator Ranking',
        description: 'Experience the charm of various creators!',
        updated_at: 'Updated {{minute}} minutes ago',
        statistics_date: '{{date}} Total',
        see_more: 'See more',
        item: {
          title: "The creator's products are all sold out!",
          sub_title: 'Support your favorite creator\nand stay tuned for new product launches!',
          fan_letter: 'Write a fan letter',
        },
      },
      limited_edition: {
        description: 'Time to Buy {{count_text}} Special Items!',
        title: 'Limited Edition Ranking',
        sub_title: '{{count_text}} limited-time items',
      },
      weekly_best_product: {
        description: 'Come and explore the popular products!',
      },
      cast_on_air: {
        description: 'Your Bias Shop is Now Available',
      },
      photo_review: {
        description: 'MaprpleShop Honest Reviews',
      },
      new_creator: {
        description: 'Marpple Debut! Emerging Line up',
      },
      lifestyle_curation: {
        description: 'For Diverse Tastes in This World',
      },
      store_direct: 'Go to to {{name}} Shop',
      popup: {
        description: 'Only available at MarppleShop',
        title: 'MARPPLESHOP POP-UP STORE',
        percent: 'Achieved',
        button: 'View all Pop-up',
      },
      creators: {
        description: 'Here to steal your heart',
      },
      contents: {
        description: 'You will be Interested in this💘',
      },
      best_product: {
        description: 'These kinds of goods are trending these days😎',
      },
      top_100: {
        title: 'Popular Products TOP 100',
        title_mo: 'Popular Products',
        sub_title: 'Which products sold the most?',
        see_more: 'More&nbsp;<span>Goods TOP 100</span>',
      },
      category_product_ranking: {
        title: 'Category Rankings',
        sub_title: 'Meet the hottest products right now!',
        tooltip:
          'Product ranking by category provides\nthe most popular products in MarppleShop\nfor one week, categorized by category.',
        empty_title: 'Ranking is being calculated!',
        empty_description_mo: 'Please select another category or\nsearch for products!',
        empty_description_pc: 'Please select another category or search for products!',
      },
      realtime: {
        title: 'Just Sold Now',
        title_mo: 'Popular Products Just Sold!',
        sub_title: 'What are others buying?',
      },
      brand_commerce: {
        title: 'Creator X Brand Products',
        sub_title: 'Greater happiness created by coming together!',
        tooltip:
          'Creator X Brand products are\ncollaborative items promoted efficiently\nand offered at a reasonable price!',
      },
      new_creator_ranking: {
        title: 'New Creators This Month',
        sub_title: 'New sensibilities, fresh ideas!',
        tooltip:
          'Our Monthly New Creator Ranking\nshowcases the most popular and standout creators\nwho joined Marpple Shop over the past week.',
      },
      funding_title: 'Notable Funding Projects',
    },
    mypage: {
      question: {
        commission: {
          title: '',
          name: '',
          number: '',
          check: '',
          button: '',
          button_studio: '',
        },
        '문의 내용': 'Inquiry Details',
        nickname: '',
        kind: 'Inquiry Type',
        제목: 'Title',
        내용: 'Detail',
        첨부파일: 'Documents attachments',
        '답변 내용': 'Response Content',
        before_answer_content: 'No response from the creator has been registered.',
        '답변 대기': 'Awaiting',
        '답변 완료': 'Completed',
        '추가 문의 내용': 'Additional Inquiry Content',
        '추가 답변 완료': 'Additional Response Completed',
        add_question: 'Additional Inquiry',
        add_answer: 'Additional Answered',
        shop_name: 'Shop',
        product_name: 'Product',
        empty_title: "You don't have any creator inquiries.",
        empty_desc: 'You can contact the creator through the product detail page &gt; Purchase instructions',
        '최근 1년간 문의 내역만 확인 가능합니다.': 'You can only see inquiries from the past year.',
        product_num: 'Product Number',
        do_add_question: 'Add Inquiry',
        do_end_question: 'Close Inquiry',
        'JPG, JPEG, PNG, ZIP, PDF 가능 | 최대 10MB': 'JPG, JPEG, PNG, ZIP, and PDF | Up to 10 MB',
      },
      no_like_creator_title: "There's no liked creators",
      no_like_creator_title_desc: 'Try pressing the like button on your favorite creator',
      no_like_product_title: "There's no liked products ",
      no_like_product_title_desc: 'Click ‘Like’ for the products you are interested in',
      order_deliver: 'Order・Shipping',
      written_review: 'Review',
      liked_products: 'Like',
      '이름을 입력해 주세요': 'Please enter your name',
      '앱 설정': 'APP Setting',
      app_setting: 'APP Setting',
      creator_apply: 'With creativity, you too<b>can be a MarppleShop creator.</b>',
      creator_apply_mo: 'Apply Creator',
      creator_apply_mobile: 'With My Own Creativity',
      logout: 'Log out',
      marppleshop: 'Make it Real at MarppleShop',
      order: {
        title: 'Purchase Details',
      },
      review: {
        title: 'My Writing',
        empty_title: 'You have not written any reviews.',
        empty_desc: 'Purchase from your favorite creators<br />and leave your first review!',
      },
      like: {
        title: 'Likes',
        empty_product_title: "There's no liked products ",
        empty_creator_title: "There's no liked creators",
        empty_product_desc: 'Click ‘Like’ for the products you are interested in',
        empty_creator_desc: 'Try pressing the like button on your favorite creator',
      },
      recent: {
        title: 'Recently visited',
        empty_product_title: 'There are no recently viewed products.',
        empty_creator_title: "There are no creators you've recently viewed.",
        empty_product_desc: 'Discover new favorites at MarppleShop!',
        empty_creator_desc: 'Find a creator you like on MarppleShop!',
        empty_product_find: 'Find More Products',
        empty_creator_find: 'Find Creators',
        product: ' product <span class="count">{{count}}</span>',
        creator: ' creator <span class="count">{{count}}</span>',
      },
      creator_question: {
        title: 'Creator Inquiry History',
      },
      creator_apply_prefix: 'With creativity, you too',
      creator_apply_suffix: 'can be a MarppleShop creator.',
      funding_apply_prefix: 'Funding goal achievers, we’ll open an',
      funding_apply_suffix: 'Pop-up Store for you.',
    },
    popup_store: {
      rate: '{{rate}} Goal Achieved',
      total: 'Total Sales Amount: ${{price}}',
      status: {
        closed: 'Closed',
      },
      tooltip:
        'The MarppleShop Popup Store is a service<br />where MarppleShop and creators collaborate to plan and produce products,<br />which are then showcased to customers.',
      tooltip_link: 'MarppleShop Pop-up Store Apply',
      archived: {
        sub_title: 'MarppleShop Pop-up Store Archived',
        group_label: '{{month}}, {{year}}',
        title: 'MarppleShop Pop-up Store Archived',
      },
      now: {
        sub_title: 'Ongoing Pop-up Store',
        go_upcoming: 'Scheduled Pop-up',
        title: 'Ongoing Pop-up Store',
      },
      upcoming: {
        sub_title: 'Upcoming MarppleShop Popup Store',
        openrun_btn: 'Open Run Apply',
        go_now: 'Ongoing Pop-up',
        title: 'Ongoing Pop-up Store',
      },
      openrun_modal: {
        title: 'Apply for Open Run',
        name_label: 'Name',
        alarm_label: 'Notification',
        email_label: 'E-mail',
        email_holder: 'Please enter your e-mail',
        valid_email: 'Please enter your e-mail',
        valid_email2: 'Please enter a valid email format',
        alert_title: 'Open Run Completed',
        alert_msg:
          'Emails will be sent 24 hours and 30 minutes \nbefore your applied popup store opens. \nPlease wait with excitement!',
        notice_li_1: 'Open notifications will be sent 24 hours and 30 minutes before the pop-up store open.',
        notice_li_2: 'Agreeing to receive promotional information is required to subscribe to notifications.',
        notice_li_3: 'Some popup stores may open later due to release delays and circumstances.',
        cancel_btn: 'Cancel',
        confirm_btn: 'Apply',
      },
      empty: {
        upcoming_title: "We're preparing an exciting pop-up store!",
        now_title: 'There are no ongoing popup stores.',
        archived_title: 'There are no ongoing popup stores.',
        desc: "We're preparing popup stores to cater to a wider range of tastes.",
        last_popups: 'Previous pop-up store',
        see_more: 'See More',
      },
    },
    login: {
      email_placeholder: 'E-mail',
      password_placeholder: 'Password',
      login: 'Login',
      find_id: 'Find ID',
      reset_password: 'Password Reset',
      invalid: 'Login Failed',
      invalid_description: 'Incorrect e-mail or password.<br>Please check the information you entered.',
      need_login: {
        title: 'Login Guide',
        message: 'You need to log in.<br/>Log in to MarppleShop and find your style!',
      },
      email_verify_sent:
        'We have sent you an verification e-mail\nto the e-mail address created when you signed up.',
      check_email: 'Please check your mailbox again.',
      resend_email: 'Resend',
      change_email: 'Change e-mail',
      email_send_ing: 'E-mail in transit',
      email_error: 'E-mail error',
      loading_title: 'Please wait a moment!',
      loading_guide: 'Redirecting to the requested page.',
      error_title: 'An error occurred during login.',
      error_guide: 'Please try again later<br/>or contact customer support.',
      cs: 'Customer Support',
      go_main: 'Go to Main',
      try_later: 'Try later',
      go_retry: 'Try again',
      creator_login_error_title: 'Log in with another account and click the link again.',
    },
    contents: {
      list_description: 'You will be Interested in this 💘',
    },
    purchase_card: {
      title: 'Purchase Card',
      creator_purchase_info_description: '<span><b>{{order}}th</b></span><span>fan to buy this！</span>',
      creator_purchase_card_info_description_1: 'Capturing special moments',
      creator_purchase_card_info_description_2: 'Authentication card is ready for you!',
      download_medium: 'Download Card',
      download_small: 'Download',
      download_success: 'Purchase card has been saved.',
      download: '{{store}}_MarppleShop_Purchase_Card',
      konva: {
        purchased_at: 'Date',
        count: 'Quantity',
      },
      status: {
        purchase: 'Completed',
        before_purchase: 'Deposit Pending',
      },
    },
    signup: {
      name_placeholder: 'Please enter your name',
      email_placeholder: 'Please enter your email',
      password_placeholder: 'Please enter your login password',
      email_invalid_message: 'Please enter a valid email format',
      password_short_message: '10+ characters',
      password_invalid_message: 'English/Number/Special character',
      signup: 'Signup',
      all_check_label: 'Agree with all',
      terms_check_label: 'Acceptance of the Terms of Use',
      privacy_check_label: 'Consent to the privacy policy',
      age_check_label: 'At least 14 years old',
      ad_check_label: 'Marketing consent (Optional)',
      more: 'View',
      data_error: 'Unverified Data',
      data_error_message:
        'Unexpected error preventing registration.<br>If this issue persists, \nplease contact<br><a href="malito:cs@marppleshop.com" style="text-decoration-line: underline">cs@marppleshop.com</a>',
      data_valid_error: 'Input Information Error',
      data_valid_error_message:
        'The email address is not valid or does not follow the correct format.<br/>Alternatively, please check if the name is missing or contains special characters.',
      check_error: 'Confirm Agreement to Terms',
      check_error_message: 'Please agree to the terms to join MarppleShop.',
      email_duplicated: 'Email Already in Use',
      email_duplicated_message:
        'This email is already registered.<br>Please log in with your existing email.',
      resend: 'Resend',
      email_verify: 'Email Verification',
      email_verify_message:
        "A verification email has been sent.<br>Once the email is confirmed, clicking the 'Verify' button<br>will complete the registration process",
      email_verify_resend: 'Resend Verification Email',
      email_verify_resend_message:
        "The verification email has been resent.<br>If it doesn't arrive within a few minutes,<br>please check the spam folder.",
      email_verify_resend_fail: 'Email verification resend failed.',
      email_verify_resend_fail_message: 'Request unsuccessful. Please try again.',
      welcome: 'Nice to Meet You !',
      welcome_message:
        "MCO account registration is complete.<br/>Let's find your own style at MarppleShop,<br/>where everything you imagine becomes real!",
      welcome_label: 'Get Started',
      consecutive_char_error: 'Password Not Available',
      consecutive_char_error_message: 'Consecutive characters or numbers are<br>not allowed in the password.',
      email_password_error: 'Password Not Available',
      email_password_error_message: 'The password cannot contain<br>the same characters as the email',
      invalid_password_error: 'Password Not Available',
      invalid_password_error_message:
        'The password must be at least 10 characters long and include letters, numbers, and special characters.',
      to_login: 'Login',
      close: 'Close',
      welcome_message_sns_connect:
        "MCO account connection is complete.<br/>Let's find your own style at MarppleShop,<br/>where everything you imagine becomes real!",
    },
    curation: {
      page_description: 'Introducing the products at MarppleShop!',
      page_sub_title: 'For Diverse Tastes in This World',
    },
    creator_view: {
      page_sub_title: 'Stories Straight from the Creators',
    },
    reset_password: {
      title: 'Password Reset',
      email: 'E-mail',
      email_placeholder: 'Please enter your email',
      request_change_email: 'Receive Password Reset Email',
      send_title: 'Password reset email send',
      send_message:
        'Check your e-mail for a link to reset your password.<br/>\nIf it doesn’t appear within a few minutes,<br/>check your spam folder.',
      error_title: 'Password reset unavailable',
      error_no_email: 'The password reset email could not be sent.<br/>Please check the email address.',
      change: 'Change Password',
      new_password: 'New Password',
      new_password_placeholder: 'Please enter your new password',
      error_new_password_length: '10+ characters',
      error_new_password_valid: 'English/Number/Special character',
      new_password_check: 'Confirm Password',
      new_password_check_placeholder: 'Please enter your new password again',
      new_password_check_valid: 'Password Match',
      error_no_password: 'Password is empty.',
      error_no_password_check: 'Password confirmation is empty.',
      error_password_no_equal: 'Passwords do not match.',
      error_code_invalid: 'Authentication code is invalid.',
      error_no_user: 'There is no account matching the information.',
      error_current_password_same: 'You cannot use the same password<br/>as the previous one.',
      success_title: 'Password reset complete',
      success_message: 'Your password has been changed.',
    },
    cart: {
      title: 'Shopping Cart',
      check_cart: 'Check Cart',
      change: 'Save',
      option_changed: 'Please add the items back to the shopping cart. (Option purchase not available)',
      no_stock: 'Please check the product again. (Option purchase not available)',
      not_enough_stock: 'Add the product back to the shopping cart. (Out of stock)',
      discontinued: 'The product is currently unavailable for purchase. (Item or option sold out)',
      empty_title: 'Your shopping cart is empty!',
      empty_desc: 'Browse Through a Variety of Products<br />Find the Perfect Products.',
    },
    search: {
      all: 'All',
      product: 'Product',
      goods: '',
      handmade: '',
      brand_deal: '',
      ebook: '',
      review: '',
      plus_shop: 'Plus Shop',
      creator: 'Creator',
      popup_store: 'Pop-up Store',
      curation: 'Curation',
      recommend: 'Recommended',
      title1: '',
      title4: 'search',
      recent_search: 'Recent Searches',
      recent_empty: 'No Recent Search History.',
      popular_search: 'Popular searches',
      empty_title: 'No search results found',
      empty_body: 'Please check if the spelling and spacing<br/>of the search terms are correct.',
    },
    checkout: {
      temp_user_info:
        'Automatic membership registration will use your order information, allowing you to log in and view your purchase history after placing the order.',
      check_pass_title: 'Re-enter password',
      input_user_info: "Enter Recipent's information ",
      input_shipping_info: 'Enter shipping address',
      duplicate_email: 'Duplicate email(s)',
      profile_change: 'Account Settings',
      header: 'Order Completed',
    },
    plus: {
      ready_for_contents: 'Preparing the content.',
      see_products_waiting_contents:
        'While the content is being prepared,<br/>how about exploring various products?',
      see_products: 'Find More Products',
      content: 'Content',
      limited: 'Limited Edition',
      best_product: 'Best Product',
    },
    plus_studio: {
      upload: 'Upload',
      brand: {
        title: 'Brand Management',
        description:
          'Try reflecting your brand identity, such as colors and logos, and apply them to your site.',
        button: 'Save',
        information_title: 'Information',
        plus_cover_title: 'Plus Cover',
        meta_tag_title: 'Meta Tag',
        logo_title: 'Plus Logo',
        name_title: 'Plus Name',
        description_title: 'Plus Introduction',
        official_title: 'Offcial Site URL',
        youtube_title: 'Youtube URL',
        instagram_title: 'Instagram URL',
        x_title: 'X URL',
        naver_blog_title: 'Naver Blog URL',
        tiktok_title: 'Tiktok URL',
        facebook_title: 'Facebook URL',
        afreeca_title: 'SOOP URL',
        chzzk_title: 'CHZZK URL',
        pc_cover_title: 'PC Image',
        pc_cover_description:
          'If the PC cover image exceeds 1440px * 640px centered, it may not be visible on some devices.',
        mo_cover_title: 'Mobile Image',
        og_image_title: 'OpenGraph Image',
        og_image_description: 'Recommended size (width 1200px, height 600px)',
        og_title_title: 'OpenGraph Title',
        og_description_title: 'OpenGraph Description',
        logo_description:
          'Please upload an image in square aspect ratio.\n(Minimum size 400px / PNG with transparent background accepted / File size under 1MB)',
        logo_upload: 'Upload',
        pc_cover_size: 'Size 2560px * 640px',
        pc_cover_type: 'PNG, JPG, JPEG accepted',
        pc_cover_volume: 'Up to 3MB',
        pc_cover_upload: 'Please register the PC Plus Shop cover image.',
        mo_cover_size: 'Size: 750px * 1276px',
        mo_cover_type: 'Formats accepted: PNG, JPG, JPEG',
        mo_cover_volume: 'Maximum size: 3MB',
        mo_cover_upload: 'Please register the mobile Plus Shop cover image.',
        title_placeholder: 'Please enter the name of Plus Shop {{name}}.',
        description_placeholder:
          'Please enter the introduction content for Plus Shop {{name}} to be featured on the home page.',
        og_title_placeholder: 'Please enter OpenGraph {{name}} title.',
        og_description_placeholder: 'Please enter OpenGraph {{name}} description.',
      },
      upload_placeholder: 'There are no files attached.',
      live: {
        live_01: 'Schedule Post',
        live_02: 'Schedule for Public',
        live_03: 'Schedule End',
        live_04: 'Create and manage video content to display on the Plus Shop homepage.',
        live_05: 'Video Banner Management',
        live_06: 'Please enter the URL of the product',
        live_07:
          "The maximum number of publications has been exceeded. The banner's publication status will be set to private",
        live_08: 'You have exceeded the maximum number of publications. You can publish up to 5 items.',
        live_09: 'Would you like to delete the video banner?',
      },
      banner: {
        editor_title: 'Apply Promotion Banner',
        editor_title_2: 'Edit Promotion Banner',
        title: 'Manage Promotion Banners',
        description: 'Add and manage content to be displayed on the Plus Shop homepage banner.',
        tab_01: 'Manage All Content',
      },
      ga_service: {
        menu: 'Integrating external services',
        title: 'Integrating external services',
        save_txt1: '',
        save_txt2: '',
      },
      popup: {
        enroll: {
          title: 'Add Popup',
          plus_description: 'Register a new popup to be displayed on the Plus Shop home.',
          all_description: 'Register a new popup to be displayed on the MarppleShop home.',
          cancel_button: 'Cancel',
          submit_button: 'Add',
          submit_success_modal_title: 'Completed',
          submit_success_home_modal_title: 'Mapleshop Home Registration Complete',
          submit_success_studio_modal_title: 'Studio Full Registration Complete',
          submit_success_modal_message:
            'The popup has been registered.\nPlease check it in the relevant settings screen.',
          delete_modal_title: 'Cancel input ',
          delete_modal_message:
            'The information you are entering will not be saved.\nDo you want to go back to the previous page?',
        },
        modify: {
          title: 'Edit',
          plus_description: 'Edit the popup displayed on the Plus Shop home.',
          all_description: 'Edit the popup displayed on the MarppleShop home.',
          cancel_button: 'Delete',
          submit_button: 'Edit',
          submit_success_modal_title: 'Completed',
          submit_success_home_modal_title: 'Mapleshop Home Update Complete',
          submit_success_studio_modal_title: 'Studio Full Update Complete',
          submit_success_modal_message:
            'The popup has been edited.\nPlease check it in the relevant settings screen.',
          delete_modal_title: 'Delete',
          delete_modal_message:
            'Once deleted, the popup cannot be restored.\nAre you sure you want to delete this popup?',
          delete_success_modal_title: 'Deletion completed',
          delete_success_modal_message: 'The deletion of the popup has been completed.',
        },
        image_description: 'Please upload a popup image',
        popup_title: 'Popup Title',
        popup_title_placeholder: 'Please enter the popup title.',
        popup_title_description: 'This title is for popup management and will not be displayed externally.',
        exposure_duration: 'Display Period',
        exposure_duration_description:
          'If you want to register as private, please set the date to a time before the current date.',
        popup_image: 'Popup Image',
        close_icon_color: 'Close Icon Color',
        button_bg_color: 'Button Background Color',
        button_text_color: 'Button Text Color',
        link_url: 'URL Address',
        link_url_placeholder: 'Enter the URL to navigate to when the pop-up image is clicked.',
        link_url_description: 'If no URL is entered, the image will not be clickable.',
        exposure_location: 'Display Location',
        exposure_home: 'Marppleshop Home',
        exposure_studio: 'Studio Overall',
        preview_title: 'Preview',
        sort_success_title: 'Sorting Complete',
        sort_success_message: 'Popup sorting has been completed.\nPlease check it on each settings page.',
      },
      creator: {
        sort: {
          title: 'Creator Sorting',
          desc: 'Change the order of creators you want to display by recommendation on the Home and Creator pages.',
          sort_title: 'Sort Order',
          sort_desc: 'Change the order with drag and drop.',
          clipboard_title: 'Clipboard',
          clipboard_desc: 'You can temporarily store creators being sorted.',
          empty_box_desc:
            'Drag creators to store them temporarily.<br/>Then move them back to the sorting area on the left to modify the sorting.',
          success_title: 'Creator Sorting Completed',
          success_message: 'Creator sorting has been updated.<br/>Please check on the PlusShop Home.',
          check_clipboard_title: 'Check Clipboard',
          check_clipboard_desc:
            'There are creators unsorted in the clipboard.<br/>Complete all sorting and press the save button.',
          button: 'Save',
        },
      },
      file: {
        image_size: '{{width}}px * {{height}}px',
        accepts: 'JPG, JPEG, PNG, GIF',
        accepts_without_gif: 'JPG, JPEG, PNG',
        max_file_volume: 'Max {{max_file_volume}}MB',
      },
    },
    file: {
      volume_error_title: 'File Upload Limit Exceeded',
      volume_error_message: 'The upload limit has been exceeded.<br/>Please upload files under {{volume}}.',
      extension_error_title: 'File attachment not possible',
      extension_error_message:
        'The selected file cannot be attached.\nPlease check the file extension again.',
      extension_forbidden_title: '',
      extension_forbidden_message: '',
      mime_type_not_allowed_title: '',
      mime_type_not_allowed_message: '',
      filename_invalid_title: '',
      filename_invalid_message: '',
      custom_validation_failed_message: 'File validation failed',
      image_size_error_title: 'Check the image size',
      image_size_error_message: 'The image size is incorrect.<br/>Please upload with {{size}} dimensions.',
      image_size_over_error_message: 'Invalid image size.<br/>Please upload a file under {{size}}.',
      image_aspect_ratio_error_title: 'Check Image Aspect Ratio',
      image_aspect_ratio_error_message:
        ' The image aspect ratio is incorrect.<br/>Please upload it in a {{aspect_ratio}} ratio.',
      volume_under_error_title: 'Upload Size Exceeded',
      volume_under_error_message:
        'The upload size requirement was not met.<br/>Please upload a file of {{volume}} or larger.',
    },
    admin: {
      menu: {
        menu_01: 'Manage Main Banners',
      },
      cast_on_air: {
        coa_01: 'Manage Cast On-Air',
        coa_02: 'Create and manage video content to be displayed on the MarppleShop homepage.',
        coa_03: 'Manage All Content',
        coa_04: 'Direct URL',
        coa_05: 'Create Cast On-Air Content',
        coa_06: 'Manage Cast On-Air Content',
        coa_07: 'Content Title',
        coa_08: 'Content Description',
        coa_09: 'iframe',
        coa_10: 'Add Product',
        coa_11: 'Please enter the URL of the product.',
        coa_12: 'You can display videos from platforms like YouTube, Afreeca TV, CHZZK, etc.',
        coa_13: 'Please enter the iframe URL address.',
        coa_14: 'Please enter the URL for the direct link button.',
        coa_15: 'Exceeded maximum number of banner publications.',
      },
      banner: {
        banner_01: 'Please upload the banner image.',
        banner_02: 'Recommended size: 896px X 1120px or larger / Up to 3MB',
        banner_03: 'PC Banner Settings',
        banner_04: 'Recommended size: 750px X 562px or larger / Up to 1MB',
        banner_05: 'Mobile Banner Settings',
        banner_06: 'Common Settings',
        banner_07: 'Mobile Banner Image',
        banner_08: 'PC Banner Image',
        banner_09: 'Banner Category',
        banner_10: 'Please enter the category in English to distinguish the banner.',
        banner_11: 'Please enter the button text to be inserted in the banner.',
        banner_12: 'Button Text',
      },
      site_manage: {
        integrating_external_services: {
          title1: 'External Service Integration',
          txt1: 'This is a page for managing integration with external services.',
          sub_title1: 'Google Analytics Settings',
          head1: 'Google Analytics Measurement ID',
          txt2: 'When you set up Google Analytics, you can view and analyze data such as visitor inflow and bounce rates for MarppleShop Plus in real-time.',
          txt3: 'Creator Guide',
          txt4: "Please enter a measurement ID in the format 'G-000000000'.",
          btn1: 'Save',
          txt3_2: 'Set up Google Analytics according to the guide!',
          save_txt1: 'Save Completed!',
          save_txt2: 'Measurement ID has been saved.\nNow check your data in Google Analytics!',
          save_fail_txt1: 'Save Failed',
          save_fail_txt2: 'Please contact customer service.',
          btn2: 'Change',
          btn3: 'Disconnect Integration',
          update_txt1: 'Change Completed!',
          update_txt2: 'Measurement ID has been changed.\nNow check your data in Google Analytics!',
          cancel_txt1: 'Integration Disconnected!',
          cancel_txt2: 'Google Analytics integration has been disconnected.',
          cancel_fail_txt1: 'Disconnection Failed',
          cancel_fail_txt2: 'Please contact customer service.',
        },
      },
    },
    cheerup: {
      txt1: 'Leave a word of support for the creators!',
      txt2: 'You can insert web page links, YouTube as text-based shortcuts.',
      txt3: 'Up to 6 images max.',
      btn_txt1: 'Fan Letter',
      title1: 'Fan Letter',
      sub_title1: 'Cheer for your Favorite Creator',
      btn_txt2: 'Edit',
      profile_txt1: 'Edit',
      profile_txt2: 'Please upload an image file within 10MB.<br />(Image formats: JPG, JPEG, PNG)',
      profile_txt3: 'Introduce Creators for your own words.',
      empty_title: 'Leave a word of support for the creators!',
      empty_body:
        'Leave a Word of Cheer for the Creator! <br />Your kindly message of support means a lot to Creator.',
      my_page_empty_body: "Visit your favorite creator's shop and<br/>write a message to show your support.",
      my_page_empty_title: 'You have not written any cheer up messages.',
      my_page_empty_button: 'Find Creators',
    },
    article: {
      sns_txt1: 'SNS',
      remove: 'Delete Fan Letter',
      remove_desc: 'Would you like to delete this fan letter?',
      remove_ok: 'Delete',
      remove_cancel: 'Cancel',
    },
    toast: {
      close: 'Close',
      goto_cart: 'Go to cart',
      goto_product: 'Go to see',
    },
    creator_shop: {
      sub_title1: 'Will hit your taste spot',
      sub_title2: 'Cheer for your Favorite Creator',
      sub_title3: "When you're curious about fans' stories",
    },
    settings: {
      style_editor: {
        file_txt1: 'Max width 320px height 20px ~ 80px | PNG | Max 1MB',
        file_txt2: '',
        file_txt3: '',
        file_txt4: '1:1 Square | Min 400px | JPG, JPEG, PNG | Max 1MB',
        banner_help_txt1: 'Banner images may be cut off on some devices if they exceed 1440px centered.',
      },
      product_editor: {
        sample_order: 'Order Sample',
      },
    },
    gnb: {
      creator_ranking: 'Creator Ranking',
      creator_ranking_weekly: 'Weekly Creator',
      creator_ranking_monthly: 'Monthly Creator',
      plus: 'MarppleShop Plus',
      plus_all: 'All MarppleShop Plus',
      creator_view: 'Creator View',
      creator_all: 'All Creator',
      creator_new: 'New Faces at MarppleShop',
      monthly_top_one: "MarppleShop's {{month}} Top Creator",
      more: 'More',
      menu: {
        home: 'Home',
        creator: 'Creator',
        popup: 'Pop-up',
        shopping: 'Shop',
        mypage: 'My Page',
        real_ranking: 'Real-time/Ranking',
        real_ranking_bottom: 'Ranking',
        recommend: 'Recommend',
        explore: 'Explore',
        goods: 'Goods',
        handmade: 'Handmade',
        brand_deal: 'Brand Deal',
        ebook: 'E-BOOK',
      },
    },
    creator_filter: {
      all: 'ALL',
    },
    price: {
      price_all: 'Total Price',
    },
    customer_order: {
      inquire: 'Inquire',
    },
    error: {
      404: {
        title: 'The page you are looking for cannot be found',
        description:
          'The address of the page you are trying to find may have been entered incorrectly,<br/>or the page may be inaccessible due to changes or deletion of the address.<br/>Please verify that the address you entered is correct.',
      },
      500: {
        title: 'Please check again later!',
        description:
          'We apologize for the inconvenience in using our service<br/>There was a temporary issue with the server.<br/>Please try again in a moment.',
      },
      suspend_store: {
        title: 'This shop is no longer active.',
        description: 'Discover new creators on MarppleShop.',
      },
    },
    adult: {
      need_verify: 'Age Verification',
      go_verify: 'Verify',
      go_main: 'Go to Main',
      verify_cancel: 'Authentication canceled',
      verify_cancel_description: 'Authentication was canceled.<br/>Please try again.',
    },
    creator_studio: {
      confirm_title1: 'Are you sure you want to disconnect?',
      confirm_body_txt1:
        'You can hide the exposed product without<br/>disconnecting YouTube from MarppleShop!',
      confirm_btn_ok: 'Disconnect',
      confirm_btn_cancel: 'Go Back',
      store_delivery_company_title: 'Shipping Policy',
      store_delivery_company_desc:
        'You can set different shipping policies if shipping fees, shipping locations, etc. differ by product.',
      external_services: {
        tab1: 'Google Analytics Settings',
        tab2: 'API Key Issuance',
      },
      terms: {
        welcome: '마플샵 스튜디오에 오신 걸 환영합니다!',
        guide: '샵을 꾸미고 상품을 만들어보세요.<br/>판매 승인 심사는 평일 영업일 기준 2~5일 소요됩니다.',
        start_service: '동의하고 스튜디오 시작하기',
        all_check: '전체 동의',
        service_check: '마플샵 스튜디오 이용약관 동의',
        privacy_check: '개인정보처리방침 동의',
        age_check: '만 14세 이상입니다.',
        not_yet: '진행 불가',
        not_yet_message:
          '크리에이터 스튜디오 이용약관 및 개인정보처리방침 및<br/>만 14세 이상에 모두 동의해 주세요.',
      },
      printable_product_alert:
        'The production draft has been generated and cannot be modified.<br>To change the design, please use the product duplication feature.',
    },
    shipping_guide: {
      departure_date_info: 'Shipping Date Guide',
      departure_date_info_marpple_desc1:
        'When you order MarppleShop Delivery products and MarppleShop Custom-made products together, the shipping fee is charged only once.',
      departure_date_info_marpple_desc2:
        'If the shipping departure dates of products ordered together are different, all items will be shipped according to the latest date.',
      departure_date_info_marpple_desc3:
        'Pre-order products may experience shipping delays, so we recommend ordering them separately from other products.',
    },
    product_detail: {
      ebook_illustrator: 'Illustration',
      ebook_translator: 'Translation',
      ebook_publisher: 'Publisher',
      ebook_publication_date: 'Publication Date',
      재고부족: 'Low Stock',
      quantity_exceeded: 'You have exceeded the available quantity for purchase.',
      remaining_stock_quantity:
        '<span style="font-weight: 700; color: #1C75FF;">Only {{remaining_stock_quantity}} item left</span> in stock for the selected option.<br/>Please check your option.',
      option_not_selected: 'Option Not Selected',
      option_not_selected_desc: 'You have not selected an option.<br />Please choose a product option.',
      out_of_stock: {
        title1: 'Product Inventory Info',
        title2: 'Product restocking planned',
        title3: 'Product Registration Notice',
        description1:
          'This product is currently out of stock.<br/>It will be available for display and sale once restocked.',
        description2:
          'The options below are temporarily out of stock<br/>and will be available for sale once restocked.',
        description3:
          '{{ len }} options of this product are available for immediate sale,<br/>while the options below will be sold after restocking.',
        submit: {
          ok: 'Register Product',
          cancel: 'Re-select Options',
        },
      },
      required_bank: {
        title: 'Account Registration Notice',
        description:
          'Before creating a product,<br/>you need to register your account information.<br/>Once your product is sold, earnings will be transferred<br/>to your registered account.',
        ok: 'Register Account',
        cancel: 'Do it later',
      },
      duplicated_option: 'Duplicate option selected',
      duplicated_option_desc: 'Option already selected.<br />Please adjust the quantity.',
      no_select_option: 'Option not selected',
      no_select_option_desc: 'No product options selected.<br />Please choose a product option!',
      over_quantity: 'Quantity exceeds limit',
      over_quantity_desc: 'Maximum quantity selected.<br />Remove an item to add more.',
      duplicated_option_desc2: 'Option already selected.<br />Please review your selection.',
      select_phonecase: 'Please select your phone model.',
    },
    funding: {
      modal: {
        title: 'Participating Fans',
        tabs: {
          ranking: 'By Ranking',
          created_at: 'By Latest',
        },
        item: {
          label: '{{nickname}} funded this.',
        },
      },
      section: {
        ranking_title: 'Participating Fan Ranking',
      },
      cta: {
        sold_out: 'Funding has ended!',
        support: 'Join Funding',
      },
      card: {
        coming_soon: 'Upcoming',
        status: {
          success: 'Project Success',
          failed: 'Project End',
          ing_day: '{{day}}d left',
          ing_hour: '{{hours}}h left',
          ing_minute: '{{minutes}}m left',
          ing_second: '{{seconds}}s left',
        },
        share: 'Share',
        toast: {
          success: 'Address has been copied.',
        },
      },
      form: {
        percentage: {
          label: 'Achievement',
          status: {
            ing: '{{goal}} won to go',
            breakthrough: '{{goal}} won reached',
            success: 'Project Success',
          },
        },
        supporters: {
          label: 'Participants',
          count: '<strong class="{{font}}">{{count}}</strong><i>people</i>',
        },
        end: {
          label: 'Until End',
          remain_day: '<strong class="{{font}}">{{remain}}</strong><i>days remaining</i>',
          remain_time: '<strong class="{{font}}">{{remain}}</strong><i>remaining</i>',
        },
      },
      guide: {
        goal: 'Target',
        participation: 'Period',
      },
      creator: {
        menu: {
          name: 'Funding',
        },
        list: {
          title: 'Total {{count}}',
        },
      },
    },
    question: {
      문의하기: 'Creator Inquiry',
      kind: 'Inquiry Type',
      qna: 'Inquire about products',
      qna_membership: 'Inquire about membership',
      qna_support: 'Inquire about sponsorship',
      plan_name: 'Plan Name',
      ' 문의와 관련된 파일을 첨부해 주세요.': 'Please attach the file',
      '개인정보수집 ・ 이용 동의': 'Agree to',
      '사용자 정보': 'User Info',
      '필수 입력사항': 'Required field',
      이름: 'Name',
      '이름을 입력해 주세요.': 'Please enter a name.',
      error: 'Error',
      연락처: 'Phone Number',
      '없이 연락처를 입력해 주세요.': '01000000000 without hyphens (-).',
      이메일: 'E-mail',
      '문의 내용': 'Inquiries',
      '문의 내용을 입력해 주세요.': 'Please enter your inquiry.',
      '문의 내용은 최대 2000bytes까지 입력 가능합니다.<br>(한글 1000자, 영문 2000자)':
        'Your inquiry can be up to 1000 characters long.<br>(1000 characters in Korean, 2000 characters in English)',
      '파일 첨부': 'Upload',
      'jpg, png, zip, pdf 확장자만 첨부 가능하며, 10MB까지 가능합니다.<br />(여러 사진을 첨부해야 한다면 zip 파일로 첨부해 주세요.)':
        'You can attach jpg, png, zip, and pdf files up to 10MB.<br />(If you need to attach multiple photos, please zip them into a single file).',
      보기: 'View',
      취소: 'Cancel',
      '문의 접수': 'Inquiry',
      '답변 받으실 이메일 주소를 입력해 주세요.': 'Please enter your email address.',
      제목: 'Title',
      '제목을 입력해 주세요.': 'Please enter a title.',
      '문의 내용을 자세하게 작성해 주세요.':
        'Please be detailed in your message.\nPlease do not repeat yourself or use profanity or abusive language.',
      file_modal_title: 'File attachment not possible',
      file_modal_content: 'The selected file cannot be attached.\nPlease check the file extension again.',
      file_modal_content_desc: '(Attachable file types: jpg, png, zip, pdf)',
      '문의 정보': 'Inquiry Info',
      upload: 'Upload',
      submit: 'Submit',
      '필수 입력 사항입니다.': 'Required field.',
      '정확한 연락처를 입력해주세요.': 'Please enter a valid contact number.',
      '정확한 이메일을 입력해 주세요.': 'Please enter a valid email address.',
      '100자 이하로 입력해주세요.': 'Please enter within 100 characters.',
      '250자 이하로 입력해주세요.': 'Please enter within 250 characters.',
      '300자 이하로 입력해주세요.': 'Please enter within 300 characters.',
      '2000bytes 이하로 입력해주세요.': 'Please enter within 2000 bytes.',
      '특수문자를 제외하고 입력해주세요.': 'Please enter without special characters.',
      '숫자만 입력해 주세요.': 'Please enter numbers only.',
      '개인 정보 수집 및 이용 동의후 접수해주세요.':
        'Please agree to the collection and use of personal information before submitting.',
      commission: {
        title: 'Commission Application Information',
        name: 'Commission Name',
        number: 'Application Number',
        check: 'Check Application',
        button: 'View Commission Details',
        button_studio: 'View Commission Application',
      },
      nickname: 'Nickname',
      qna_commission: 'Commission Inquiry',
      add_answer:
        'After checking the inquiry content, please respond in a way that is easy for the customer to understand.',
    },
    studio: {
      editor: {
        max_length_10_txt: 'You can upload up to 10 product detail images.',
        instagram_error_title: 'Instagram Link Unavailable',
        instagram_error_description:
          'The current URL is not supported.\nPlease enter the URL of a public post.',
      },
      welcome_title: 'Welcome to<br/>MarppleShop Studio!',
      welcome_guide: 'Create custom goods anytime, anywhere<br/>on PC or smartphone.',
      page: {
        products: 'MarppleShop Production Products',
        products_guide: 'Create MarppleShop products in just 3 minutes with your designs.',
        products_order: 'Order History',
        products_order_guide: 'Check your weekly order history.',
        products_creator: 'Add to Creator Delivery Products',
        products_creator_guide: 'Sell products you have in stock or handmade items.',
        products_creator_inventory: 'Inventory',
        products_creator_inventory_guide: 'Check and manage your listed products.',
        products_creator_order: 'Order',
        products_creator_order_guide: 'View and manage new order information.',
        products_creator_shipment: 'Shipping/Delivery',
        products_creator_shipment_guide: 'Manage shipment processing and delivery information.',
        products_creator_refund: 'Refund',
        products_creator_refund_guide: 'Check and handle refund requests.',
        products_digital: 'Add to Digital/E-book',
        products_digital_guide: 'Sell various digital products quickly and easily.',
        products_digital_order: 'Order History',
        products_digital_order_guide: 'View order history for Digital/E-book',
        question: 'Inquiry',
        question_guide: 'Respond to customer inquiries.',
        store_style: 'Shop Design',
        store_style_guide: 'Customize your shop with profile, logo, and banner updates.',
        store_product_arrangement: 'Arrange Product',
        store_product_arrangement_guide: 'Rearrange your shop’s products by dragging them.',
        store_info: 'Shop Info',
        store_info_guide: 'Manage the basic information of your shop.',
        store_ecommerce_info: 'Creator Information',
        store_ecommerce_info_guide: 'Enter details for creator delivery products.',
        youtube_connection: 'Sell MarppleShop products on your YouTube channel!',
        youtube_connection_guide:
          'MarppleShop is the first official partner platform for YouTube product sales in Korea.',
        open_api: 'API Integration',
        open_api_guide: 'Manage integrations with external services.',
        adjustments: 'Settlement',
        adjustments_guide:
          'You can check the monthly settlement details based on the settlement criteria for each product and service.',
        withdraws: 'Withdrawal Application',
        withdraws_guide: 'You can withdraw the sales profits created during a month.',
        bank_account: 'Register Account Info',
        bank_account_guide:
          'You can receive the profit settlement with the account info. you had entered before.',
        products_analytics: 'Product Sales Analysis',
        products_analytics_guide: 'Check the sales rankings of your products.',
        faq: 'FAQ',
        faq_guide: 'Find answers to frequently asked questions from creators.',
        solution: 'Receive Reporting',
        solution_guide: 'Review reports filed against your shop or products.',
      },
      tooltip: {
        adjustments:
          '<h4>MarppleShop Product Settlement</h4><div>Calculated monthly based on the shipping date.</div><br/><h4>Product Settlement{{tpl_adjustments}} & Digital Product Settlement</h4><div>Calculated monthly based on the purchase confirmation date.</div>',
        withdraw_amount:
          '<div>MarppleShop Product Settlement Amount + Product Settlement Amount = Scheduled Withdrawal Amount</div><br/><h4>What is the MarppleShop Product Settlement Amount?</h4><br/><div>- Individual Creators<div>MarppleShop Product Settlement Amount - VAT (10%) - Withholding Tax (3.3%)<br />= Goods Settlement Amount</div><br/>- Business Creators <div>MarppleShop Product Settlement Amount = MarppleShop Product Settlement Amount<br/>※ For businesses, withdrawal is available only after issuing a tax invoice.</div></div>',
        pg_commission_title: 'PG Commission',
        pg_commission_desc: 'The price includes a 3.2% payment gateway fee plus 10% value-added tax.',
      },
    },
    share: {
      marppleshop_description: 'The creator commerce platform<br/>MarppleShop',
      store_main_description: "Discover [{{creator_name}}]'s exclusive merchandise at MarppleShop.",
      plus_main_description: 'A chance to discover official merchandise at [{{plus_name}}]!',
      creator_view_description: "Listen to [{{creator_name}}]'s story on MarppleShop",
      marppleshop_app_download: 'Download the App',
    },
    order: {
      country: 'Country',
    },
    seller_studio: {
      shop_management: {
        shop_info: {
          save: 'Save',
          ciety: {
            label: 'CIETY Integration',
            button: 'Create CIETY',
            prefix: 'ciety.xyz/@',
            placeholder: 'Please enter the Ciety community domain.',
            connecting: 'Integration Request in Progress',
            disconnect: 'Disconnect Integration',
            disconnect_confirm_message_title:
              'The integration between MarppleShop Creator Shop and the community will be disconnected.\nPlease make sure to check the following information.',
            disconnect_confirm_message_1:
              'If you disconnect the integration, all community benefits of the membership plan and membership\ngroups in the community will be deleted.',
            disconnect_confirm_message_2:
              'An email notifying the deletion of community benefits will be automatically sent to membership members.',
            disconnect_confirm_message_3: 'This action cannot be undone, so please proceed with caution.',
            is_mobile: 'Please proceed on PC.',
          },
          category: {
            label: 'Category',
            select: 'Selection',
          },
          style: {
            label: 'Style',
            add: 'Add',
            edit: 'Edit',
            title: 'Creator Category',
            cancel_button: 'Cancel',
            save_button: 'Save',
          },
          phone: {
            label: 'Customer Service Number',
          },
        },
      },
      question_list: {
        tab: {
          all: 'All',
          product: 'Product Inquiry',
          membership: 'Membership Inquiry',
          support: 'Support Inquiry',
          commission: 'Commission Inquiries',
        },
        filter: {
          create_at: 'Created Date',
          search_key: 'Search Condition',
          status: 'Status',
          reset: 'Reset',
          search: 'Search',
        },
        table: {
          status: 'Status',
          create_at: 'Registration Date & Time',
          user_name: 'Name',
          nickname: 'Nickname',
          title: 'Title',
          product_name: 'Product Name',
          order_id: 'Order Number',
          product_id: 'Product Number',
          phone_number: 'Phone Number',
          email: 'Email',
          plan_name: 'Plan Name',
          product_or_plan_name: 'Product/Plan Name',
        },
        status: {
          question: 'Inquiry Received',
          answer: 'Answer Completed',
          add_question: 'Additional Inquiry Received',
          add_answer: 'Additional Answer Completed',
        },
      },
      navigation: {
        welcome: 'Start MarppleShop',
        mps_product: 'MarppleShop Production Products',
        make_product: 'Add Products',
        orders: 'Order History',
        creator_product: 'Creator Delivery Products',
        shipping: 'Shipping',
        digital_product: 'Digital/E-book',
        customer_management: 'Customer Management',
        youtube_connect: 'YouTube Shopping',
        open_api: 'API Integration',
        adjustments: 'Settlement',
        creator_support: 'Support Center',
        product_adjustments: 'Settlement',
        product_sales_analytics: 'Sales Analysis',
        orders_management: 'Order',
        membership_commission_support: 'Membership/Commission/Support',
        membership: 'Create Membership',
        commission: 'Create Commission',
        support: 'Create Support',
        membership_commission_support_management: 'Membership/Commission/Support Management',
        membership_guide: 'Service Introduction',
        membership_adjustments_share: 'Revenue Share Settings',
        product_inquiry: 'Product Inquiry',
        product_management: 'Product Management',
        sales_management: 'Sales Management',
        integrated_order_search: '',
      },
      editor: {
        pbg: {
          new: {
            title: '',
          },
          modify: {
            title: '',
          },
        },
        tpl: {
          modify: {
            title: '',
          },
        },
        oversea: {
          modify: {
            title: '',
          },
        },
      },
      onBoarding: {
        title: 'Welcome!',
        title_finish: 'Congratulations!',
        desc: 'Receive 3,000 points usable on MarppleShop upon completing studio onboarding.',
        desc_finish:
          '3,000 points have been successfully credited for use on MarppleShop!<br/>Congratulations on your debut!',
        count_desc: 'remaining',
        complete: 'Complete',
        start: {
          cate_title: 'Start MarppleShop',
          shop_info_setting: {
            item_title: 'Set Shop Information',
            item_desc:
              'Set up basic information like the shop name, description, and domain visible to customers.',
            item_full_desc:
              'Set up basic information like the shop name, description, and domain visible to customers.<br/>Accurate details can boost shop visitors by over 10%.',
            button_text: 'Set Up',
          },
          shop_deco_setting: {
            item_title: 'Customize Your Shop',
            item_desc: 'Decorate your shop to freely express your unique style.',
            item_full_desc:
              'Decorate your shop to freely express your unique style.<br/>Customizing your shop can increase customer dwell time by an average of 25%.',
            button_text: 'Customize',
          },
          creator_info_setting: {
            item_title: 'Enter Creator Information',
            item_desc: 'Enter the required information for selling creator delivery products..',
            item_full_desc:
              'Enter the required information for selling creator delivery products..<br/>A shop with clear details can see a 10% increase in likes.',
            button_text: 'Enter Info',
          },
          bank_info_setting: {
            item_title: 'Bank Information',
            item_desc: 'Register your bank account details to receive settlements.',
            item_full_desc:
              'Register your bank account details to receive settlements.<br/>Securely withdraw earnings to enhance operational stability.',
            button_text: 'Register',
          },
          title: 'Start Studio',
          desc: 'Create your own shop!',
        },
        sales: {
          cate_title: 'Start Selling',
          mps_product_sales: {
            item_title: 'Add to MarppleShop Production Products',
            button_text: 'Get started',
            item_desc: 'If you have a design, you can register products on MarppleShop.',
            item_full_desc:
              'If you have a design, you can register products on MarppleShop.<br/>MarppleShop handles everything from production to delivery, customer service, and inventory management.',
          },
          creator_product_sales: {
            item_title: 'Add to Creator Delivery Products',
            item_desc: "Sell products you've created or have in stock.",
            item_full_desc:
              "Sell products you've made or have in stock.<br/>Register your unique products, engage with your fans, and generate income.",
            button_text: 'Get started',
          },
          digital_product_sales: {
            item_title: 'Add to Digital/E-book',
            item_desc: 'Sell digital products such as wallpapers, GoodNotes, eBooks, etc.',
            item_full_desc:
              'Sell digital products such as wallpapers, GoodNotes, eBooks, etc.<br/>Generate income through digital products.',
            button_text: 'Get started',
          },
        },
        debut: {
          cate_title: 'Debut on MarppleShop',
          sns_setting: {
            item_title: 'Set up your main SNS',
            item_desc: 'Let your fans easily and quickly connect with you through your SNS.',
            item_full_desc:
              'Let your fans easily and quickly connect with you through your SNS.<br/>You can secure more fans and increase traffic inflow through your SNS.',
            button_text: 'Get started',
          },
          chat_cheer: {
            item_title: "Engage through the 'Cheer Up' feature",
            item_desc: "Engage with your fans through the 'Cheer Up' board.",
            item_full_desc:
              "Engage with your fans through the 'Cheer Up' board.<br/>Strengthening communication with fans will boost brand loyalty.",
            button_text: 'Get started',
          },
          creator_guide: {
            item_title: "Check the Creator's Guide",
            item_desc: 'Check the essential guide for successful shop management.',
            item_full_desc:
              'Check the essential guide for successful shop management.<br/>Learn how to manage your shop successfully and build a better income model.',
            button_text: 'Get started',
          },
        },
        quick: {
          menu_title: 'Sell Products',
          menu_mps_product: 'Add to MarppleShop Production Products',
          menu_creator_product: 'Add to Creator Delivery Products',
          menu_digital_product: 'Add to Digital/E-book',
          online_popup_link: 'Online <br/>Popup Store',
          offline_popup_link: 'Offline <br/>Popup Store',
          youtube_link: 'YouTube Shopping',
          youtube_link_desc: 'Sell MarppleShop products directly<br/>on your YouTube channel!',
          guide_link: 'Creator Guide',
          guide_link_desc: 'Easily and conveniently use<br/>MarppleShop Studio!',
          commerce_creator_title: 'Commerce Creator 2nd Generation Recruitment',
          commerce_creator_desc: "We'll match brands that are<br/>perfect for your channel.",
          purchase_analyze_title: 'New Feature: Cumulative Sales by Product',
          purchase_analyze_desc:
            'How well did each product sell?<br/>Use this as a reference for your sales strategy.',
          sales_trend_title: 'New Feature: Sales Trends by Period',
          sales_trend_desc:
            "Is your shop's revenue growing?<br/>Check sales performance for specific periods.",
          goods_partner_title: 'Apply for Goods Partners',
          goods_partner_desc: 'VTubers, apply now!<br/>We handle goods production from A to Z',
          category_renewal_title: 'Product Category System Update',
          category_renewal_desc: 'Products will be updated to new categories (July 28, 2025)',
        },
        continue: 'Continue',
        completed: {
          title: 'Complete',
          desc: 'Now, start your own shop.',
        },
        caution: 'Point allocation may take up to 1 minute.',
      },
      adjustment: {
        marppleshop_product: 'MarppleShop Production Products',
        creator_product: 'Creator Delivery Products',
        tpl_product: 'In-stock Products',
        digital_product: 'Digital/E-book',
        amount: '{{product}} Settlement Amount',
      },
      product_guide: {
        title: 'What are MarppleShop Production Products and Creator Delivery Products?',
        about_pod: 'MarppleShop Production Products',
        pod_guide_001: 'You can sell goods designed by you without having to make them yourself.',
        pod_guide_002:
          'This refers to products for which Mapleshops handles everything, including production, shipping, customer service, and inventory management.',
        about_pb: 'Creator Products',
        pb_guide_001:
          'These are products you make and ship yourself, which can be registered in just 3 minutes without a complicated approval process.',
        pb_guide_002:
          'They are products you can start selling immediately through your own shop or a direct link.',
      },
      inspect_stores_products: {
        header: {
          title: 'Product Inspection',
          description: 'This is a page for inspecting newly registered creator delivery products.',
          list_title: 'Inspection Management',
          list_description:
            'This is a page where you can check and manage the inspection status of all creator products.',
        },
        filter: {
          create_at: 'Registration Date',
          search_key: 'Search Criteria',
          status: 'Progress Status',
          reset: 'Reset',
          search: 'Search',
        },
        table: {
          product_name: 'Product Name',
          creator_name: 'Creator Name',
          store_name: 'Shop Name',
          product_id: 'Product Registration Number',
          product_type: 'Product Type',
          category: 'Main Category/Sub-category',
          delivery_type: 'Delivery Type',
          delivery_way: 'Delivery Method',
          product_price: 'Selling Price',
          delivery_price: 'Shipping Fee \n (Standard/Remote Areas)',
          kc_certificate: 'KC Certification and Other Certifications',
        },
        status: {
          approved: 'Inspection Completed',
          rejected: 'Sales Pending',
          not_started: 'Inspection Incomplete',
        },
      },
      membership_setting: {
        title: 'Membership Settings',
        tooltip_content:
          'Set as a membership product benefit.\nApplied as a product benefit that can only be purchased by members who have joined the selected membership.\n* Membership product sales will begin when the membership plan is public.',
        private: 'Private',
      },
      popup: {
        sort_option: {
          all: 'All',
          public: 'Public',
          private: 'Private',
          reservation: 'Scheduled',
        },
        tab: {
          all: 'All Popups',
          sort: 'Change Popup Order',
        },
        list: {
          title: 'Manage Popups',
          description: 'Manage popups displayed on the Creator Shop main page.',
          submit_button: 'Register',
          save_button: 'Save',
          add_card_description: "Add and manage popups for your shop's main page.",
          mo_add_card_description: "Add and manage popups for your shop's main page.",
        },
        enroll: {
          title: 'Register Popup',
          description: 'Register a new popup for your Creator Shop main page.',
          cancel_button: 'Cancel',
          submit_button: 'Register',
        },
        modify: {
          title: 'Edit Popup',
          description: 'Edit the popup shown on the Creator Shop main page.',
          cancel_button: 'Delete',
          submit_button: 'Edit',
        },
        image_description: 'Please upload a popup image.',
        popup_title: 'Popup Title',
        popup_title_placeholder: 'Please enter the popup title.',
        popup_title_description:
          'This title is for internal management only and will not be displayed externally.',
        exposure_duration: 'Display Period',
        exposure_duration_description: 'To keep it private, set a date earlier than today.',
        popup_image: 'Popup Image',
        close_icon_color: 'Close Icon Color',
        button_bg_color: 'Button Background Color',
        button_text_color: 'Button Text Color',
        link_url: 'URL Address',
        link_url_placeholder: 'Enter the URL to redirect when the popup image is clicked.',
        link_url_description: 'If no URL is entered, clicking will be disabled.',
        exposure_location: 'Display Screen',
        exposure_home: 'Home Screen',
        exposure_product_detail: 'Product Detail Page',
        exposure_home_and_product_detail: 'Home + Product Detail Page',
        exposure_all: 'All Products',
        exposure_mps: 'MarppleShop Production Products',
        exposure_tpl: 'MarppleShop Delivery Products',
        exposure_pbg: 'Creator Delivery Products',
        exposure_dtg: 'Digital/E-book',
        exposure_custom: 'Manual Input',
        preview_title: 'Preview',
        home_and_product_detail_description:
          'Popups will be shown on the Creator Shop home and all product detail pages.',
        home_description: 'Popups will be shown on the Creator Shop home.',
        product_input_placeholder: 'Enter the product URL where the popup will be shown.',
        product_input_description: 'The popup will appear on the product detail page of the entered URL.',
        sort_success_title: 'Popup Sorting Completed',
        sort_success_message: 'Popup sorting is complete.\nPlease check it on each settings screen.',
      },
      integrated_order_search: {
        description: '',
      },
    },
    ad_res: {
      terms_modal: {
        title: 'Agree to Collection and Use of Personal Information',
        content_title_1: 'Collection & Usage Organization',
        content_title_2: 'Collected Items',
        content_title_3: 'Purpose of Collection & Use',
        content_title_4: 'Retention & Usage Period',
        content_description_1: 'Marpple Corporation',
        content_description_2: '(Required) Name, contact information, email',
        content_description_3: 'Application for MarppleShop Creator and service provision',
        content_description_4: '1 year from the application date',
        tip: 'The provider of personal information has the right to refuse consent to the collection and use of their information. However, in such cases, application and notifications for the creator will not be possible.',
        submit: 'Confirm',
      },
      title: 'Apply to Become a MarppleShop Creator',
      description_1: 'Turn your imagination into reality at MarppleShop.',
      description_2:
        'Anyone, whether an individual or a business, can apply. As long as you have products or content that you design and create yourself or own the copyright to, you can join.',
      mo_description_2:
        'Anyone, whether an individual or a business, can apply. <br /> As long as you have products or content that you design and create yourself or own the copyright to, you can join.',
      required: 'Required',
      required_one: 'Required for more than one item',
      required_one_optional: 'Select at least one',
      basic_info: 'Basic Information',
      brand_name: 'Shop Name',
      brand_placeholder: 'Please enter the shop name.',
      brand_validation: 'Please enter between 2 to 20 characters.',
      domain_name: 'Domain Name',
      domain_placeholder: 'your_domain',
      domain_validation: 'Enter 2 to 20 characters using letters, numbers, and underscores (_).',
      domain_validation_error: 'Use 2 to 20 letters, numbers, or underscores (_) only.',
      domain_duplicate: 'This domain is already in use. Please enter a different domain.',
      creator_cate: 'Creator Category',
      apply: 'Apply',
      introduce: 'Introduction',
      introduce_placeholder: 'Please introduce yourself or your shop.',
      introduce_error: 'Please enter within 200 characters.',
      contact_info: 'Contact Information',
      email_name: 'Email',
      email_placeholder: 'Please enter your email.',
      email_error: 'Please enter a valid email address.',
      phone: 'Phone Number',
      phone_placeholder: 'Please enter only numbers without hyphens (-).',
      phone_error: 'Please enter a valid phone number without hyphens (-).',
      portfolio: 'SNS / Portfolio',
      portfolio_sub: 'Please enter at least one SNS or portfolio that best represents you.',
      sns: 'Primary SNS',
      sns_placeholder: 'Please enter the URL of your active SNS channel.',
      url_error: 'Please enter a valid URL format.',
      portfolio_file: 'Portfolio File',
      portfolio_file_validation:
        'You can upload files in JPG, PNG, PPT, KEYNOTE, or PDF format, up to 50MB. (Up to 3 files can be uploaded)',
      file_upload: 'File Upload',
      delete: 'Delete',
      website: 'Portfolio Website',
      website_placeholder:
        'Please enter the URL of your personal website, Notefolio, Behance, or other relevant sites.',
      mo_website_placeholder: 'personal website, Notefolio, Behance, or other relevant sites.',
      agreement: 'Agree to Collection and Use of Personal Information',
      agree_all: 'Agree to All',
      necessary: '[Required]',
      agree_privacy:
        'I have reviewed and agree to the terms regarding the collection and use of personal information.',
      mo_agree_privacy:
        'I have reviewed and agree <br/> to the terms regarding the collection and use of personal information.',
      view: 'View',
      agree_terms: 'At least 14 years old',
      notification: 'Please Read!',
      notification_1:
        'The copyright of the content sold belongs to the creator, and submitting an application is considered as confirmation of copyright ownership.',
      notification_2:
        'The creator is responsible for posting images, designs, etc., that infringe on the rights of others or damage their reputation.',
      notification_3:
        'Your personal information will only be used for the agreed purposes. You can request to view, correct, or delete it via the personal information manager (partner@marppleshop.com) or customer service (1566-5496).',
      letter_count: '',
      email_duplicate: 'Repeated e-mail',
      finish_title: 'We’ve sent you the shop creation link, please check your email!',
      finish_title_mo: 'We’ve sent you the shop creation link <br/> please check your email!',
      finish_description_1: 'Start building your shop and creating products now!',
      finish_description_2:
        'If you haven\'t received the email, please check your <br/> spam folder or contact us at <a href="mailto:cs@marppleshop.com">cs@marppleshop.com</a>.',
      finish_info_desc:
        'Please note that your application may be rejected if there is insufficient reference material or inappropriate content.',
      finish_info_desc_mo:
        'Please note that your application may be rejected <br/>if there is insufficient reference material or inappropriate content.',
      file_upload_count_error_title: 'Upload Limit Exceeded',
      file_upload_count_error_desc: 'You can upload up to 3 files. <br /> Please upload 3 or fewer files.',
      file_upload_confirm: 'Confirm',
      file_upload_size_error_title: 'File Size Limit Exceeded',
      file_upload_size_error_desc: 'You can upload files up to 50MB. <br /> Please upload files under 50MB.',
      file_upload_error_title: 'File upload failed.',
      file_upload_error_desc:
        'Try it again, or contact<br/><a href="mailto:partner@marppleshop.com">partner@marppleshop.com.</a>',
      apply_cancel: 'Cancel',
      creator_apply: 'Apply as Creator',
      apply_desc:
        'If the phone number or email is incorrect, <br /> the link to create your Marpple Shop will not be sent. <br /> Please verify your information.',
      agree_personal: 'Please agree to the collection and use of the personal information.',
      agree_age: 'Agree that you are 14 years old or over.',
      file_uploading: 'Files are being uploaded. Try it again after uploading',
      brand_validation_error:
        'Enter the field in the combination of English / Korean / number with 2~20 letters.',
      fail_same_email:
        "The same e-mail was found in the previous application.<br/>If you haven’t received the e-mail, check the spam box. If you still can’t find it in the spam box, inquire to <a href='mailto:partner@marppleshop.com'>partner@marppleshop.com</a>",
      fail_apply:
        "Application for creator hasn’t been complete.<br/>Please try it again, or contact <a href='mailto:partner@marppleshop.com'>partner@marppleshop.com</a>",
    },
    membership: {
      join: 'Join Membership',
      join_success: 'Membership joined',
      product: 'Membership Product',
      plan: 'Plan',
      error: {
        token_expired_title: 'Membership Verification Expired',
        token_expired_description:
          'Membership verification has expired due to inactivity.<br/>The page will reload for verification.',
        widget_activate_title: 'Membership Widget Error',
        widget_activate_description:
          'An error occurred before displaying the membership widget.<br/>The page will reload to try again.',
      },
      payment: 'Pay Membership',
      go_join_button_label: 'Join Membership',
      go_join_button_label_already: 'Membership Active',
      common: {
        membership: 'Membership',
      },
      main: {
        title: 'Membership',
        sub_title: 'Membership',
        description: 'A moment that makes our connection even more special',
      },
      commission: {
        title: 'Commission',
        sub_title: 'Commission',
        description: 'A special creation just for me',
        state_pending: 'Pending Acceptance',
        state_end: 'Purchase Confirmed',
        state_accepted: 'In Progress',
        state_on_refund: 'Pending Refund',
        state_refunded: 'Canceled/Refunded',
        state_task_done: 'Completed',
      },
      support: {
        title: 'Support',
        sub_title: 'Support',
        description: 'The power to continue creating—join the creator campaign!',
        go_support_button_label: 'Support Now',
      },
      paymethod: 'Payment Method',
      starter_modal: {
        sub_title: 'To strengthen the bond between creators and fans —',
        title: 'Recruiting MarppleShop Creator Membership Starters!',
        desc: 'We are recruiting starter creators to try out the MarppleShop Creator Membership feature, launching officially in March 2025.<br/>Provide special benefits and experiences to your fans,<br/>and become a MarppleShop Membership Starter who creates new revenue opportunities!',
        guide: 'Membership Service Overview',
        apply: 'Apply for Membership Starter',
        not_today: "Don't show again today",
        desc_mobile:
          'Launching officially in March 2025,<br/>be one of the first to try the MarppleShop Creator Membership.<br/>Offer exclusive benefits and experiences to your fans,<br/>and become a MarppleShop Membership Starter<br/>who creates new revenue streams!',
      },
      membership_detail: 'Membership Details',
      support_detail: 'Support Details',
      commission_detail: 'Commission Details',
    },
    popup: {
      close_today: "Don't show again today",
      close: 'Close',
    },
    creator_ranking: {
      title_main: '{{tab}} Creator Ranking',
      sub_title: 'A burst of charm from diverse creators!',
      realtime: 'Real-time',
      weekly: 'Weekly',
      monthly: 'Monthly',
      list_title: 'Top 100 {{tab}} Creator Rankings',
    },
    collaboration: {
      title: 'Propose Collaboration',
      creator_name: 'Creator Name',
      collaboration_type: 'Proposal Type',
      collaboration_type_description: 'Multiple selections allowed',
      collaboration_category: 'Collaboration Category',
      collaboration_category_placeholder: 'Select category',
      collaboration_category_etc_placeholder: 'Please enter a custom collaboration category.',
      proposal_content: 'Proposal Details',
      proposal_content_placeholder:
        'Enter the collaboration proposal details for the creator.\n1. Reason and summary\n2. Group purchase: Product name / selling price / commission (%)\n3. Advertisement: Product name / ad type (branded, YouTube Shorts, TikTok, etc.) / ad cost\n4. Live commerce: Product name / price / incentive structure (appearance fee or sales commission)',
      proposal_content_description: 'You can enter up to 2000 bytes.',
      brand_name: 'Company/Brand Name',
      brand_name_placeholder: 'Enter your company/brand name.',
      brand_url: 'Brand Website URL',
      brand_url_placeholder: 'Enter your brand website URL.',
      manager_name: 'Manager Name',
      manager_name_placeholder: 'Enter the manager’s name.',
      manager_tel: 'Manager Contact',
      manager_tel_placeholder: 'Enter the manager’s contact number.',
      manager_email: 'Manager Email',
      manager_email_placeholder: 'Enter the manager’s email address.',
      announcement: {
        explanation:
          "'Propose Collaboration' is a page for brands to select creators they want to work with and <strong>propose a brand commerce collaboration</strong>.",
        response:
          'After submitting your proposal, <strong>a Marpple Shop representative will respond within 5 business days</strong> via the contact information provided.',
        rejection: 'The proposal may be declined based on the creator’s intent.',
        apply:
          'If you wish to join Marpple Shop as a creator, please use <a href="{{href}}">Apply as a Marpple Shop Creator</a>.',
      },
      type: {
        group_buy: 'Group Purchase',
        ads: 'Advertisement',
        live: 'Live Commerce',
        tiktok: 'TikTok Shop (Global)',
        youtube: 'YouTube Shopping (Global)',
      },
      category: {
        food: 'Food',
        beauty: 'Beauty',
        fashion_accessory: 'Fashion/Accessories',
        electronics: 'Home Electronics',
        home_living: 'Home/Living',
        pets: 'Pets',
        sports: 'Sports',
        travel: 'Travel',
        etc: 'Other',
      },
      alert: {
        success_title: 'Collaboration Proposal Submitted',
        success_description:
          'We will respond to the contact information you provided within 5 business days.\nPlease note that the proposal may be declined depending on the creator’s decision.',
      },
      cancel: 'Cancel',
      proposal_collaboration: 'Propose Collaboration',
    },
    section_title: {
      plugin: {
        soldout_label: 'Exclude sold-out products',
        see_more: 'See more',
      },
      section_tabs: {
        popup_store: 'Popup',
        curation: 'Curation',
        creator_view: 'Creator View',
        creator_ranking: 'Creator Ranking',
        plus_shop: 'Plus Shop',
        creator_search: 'Creator',
        photo_review: 'Photo Reviews',
        partners: 'Partners',
      },
      sub_title: {
        popup_store: 'Only available on MarppleShop',
        creator_ranking: 'Creators full of charm!',
        creator_search: 'Find creators that match your taste!',
        plus_shop: 'Official goods only on MarppleShop',
        latest_curation: 'Latest Curation',
        latest_creator_view: 'Latest Creator View',
        latest_contents: 'Latest Contents',
        creator_product: 'Creator’s Products',
        partners: '마플샵의 공식 크리에이터',
      },
    },
    partners: {
      apply_button: 'Apply Now',
      apply_sub_title: 'Marppleshop Goods Partners',
      apply_sub_title_mo: 'A Creative World Connected by Goods',
      apply_title: 'Official Partners of Marppleshop<br />Meet Our Creators!',
      apply_title_mo: 'Official Partners<br />of Marppleshop',
      apply_description:
        'Creators focus solely on making content,<br />while MARPPLESHOP supports everything from planning to sales.',
      footer_apply_title: 'Should I try becoming a partner too?',
      footer_apply_description: 'Turn your world into goods with Marppleshop today.',
    },
    creator_summary: {
      compact:
        '<div><b data-user-count class="{{bold}}">{{cart_user_count}}</b></div><div><span>fans adding</span></div><div><b data-product-count class="{{bold}}">{{cart_product_count}}</b></div><div><span>to cart!</span></div>',
      normal:
        '<div><b class="{{bold}}">{{cart_user_count}}</b>&nbsp;<span>people</span></div><div><b class="{{bold}}">{{name}}</b><span>\'s products</span></div><div><b class="{{bold}}">{{cart_product_count}}</b><span>&nbsp;items in cart!</span></div>',
      fan: 'Fan',
      fan_letter: 'Fan Letter',
      like_count: '',
      fan_letter_count: '<span>{{fan_letter_count}}</span><span> letters</span>',
      category_none: 'Uncategorized',
      not_cart_summary:
        '<div><b class="{{bold}}">{{name}}</b><span>\'s products – Add them to your cart!</span></div>',
    },
    creator_search: {
      search_result: 'Search results for <span class="{{klass}}">{{search_count}}</span> items',
      search_module: {
        title: 'Everything About MarppleShop Creators',
        sub_title: 'creators.<br />Meet them now!',
        sub_title_mo: 'creators.<br />Meet them now!',
        place_holder: "Please enter the creator's name.",
        recent_search: 'Recent',
        delete_auto_completes: 'Clear All',
      },
      card: {
        fan: 'Fan',
        fan_letter: 'Fan Letter',
        ranking: 'Ranking',
        shop_button_label: 'Go to Shop',
        proposal_button_label: 'Propose',
      },
    },
    ranking: {
      realtime: 'Real-time',
      realtime_best: 'Real-time Best',
      weekly: 'Weekly',
      weekly_best: 'Weekly Best',
      monthly: 'Monthly',
      monthly_best: 'Monthly Best',
      cate_roots: {
        ranking: 'Ranking',
        goods: 'Goods Ranking',
        handmade: 'Handmade Ranking',
        brand_deal: 'Brand Deal Ranking',
        ebook: 'E-BOOK Ranking',
      },
    },
    product_ranking: {
      title: 'Popular Product Ranking',
      description: 'Come and explore\nthe popular products!',
    },
    landing: {
      file: {
        helper_message: 'Please upload files under 20MB such as PDF, PPTX, JPG, PNG, etc.',
        not_available_file: 'This file cannot be uploaded. Please try again.',
        file_size_error: 'The uploadable capacity has been exceeded.',
      },
      popup_store: {
        submit: 'Apply for Online Pop-up Store',
        motion_description: 'With MarppleShop, the creator commerce platform',
        motion_title: 'A special experience created online,<br />MarppleShop Pop-up Store',
        ad_title_1:
          'Offline pop-up store <br/>venue rental, product production, operation labor costs...<br/>Are the costs burdensome?',
        mo_ad_title_1: 'Are pop-up store costs<br/>burdensome?',
        ad_description_1:
          "Don't worry! MarppleShop Pop-up Store is an online pop-up store exposed on the creator commerce platform,<br/>MarppleShop, with no separate venue rental costs.<br/>Plus, MarppleShop helps with everything from product production to online sales and shipping!",
        mo_ad_description_1:
          'MarppleShop Pop-up Store is an online pop-up store<br/>exposed on the creator commerce platform, MarppleShop,<br/>with no separate venue rental costs. Plus, MarppleShop<br/>helps with everything from product production to online sales and shipping!',
        ad_title_2:
          'Are you thinking about events that will<br/>surprise fans, such as new product launches,<br/>comebacks, or other events?',
        mo_ad_title_2: 'Are you planning an event<br/>that will surprise fans?',
        ad_description_2:
          'Many business brands and creators are already<br/>using MarppleShop Pop-up Store when they want to<br/>showcase special products and content to fans!',
        mo_ad_description_2:
          'Many business brands and creators are already<br/>using MarppleShop Pop-up Store when they want to<br/>showcase special products and content to fans!',
        ad_title_3: 'Are you worried about<br/>having leftover inventory<br/>from your offline pop-up store?',
        mo_ad_title_3: 'Are you worried about<br/>having leftover inventory?',
        ad_description_3:
          "Don't worry!<br/>MarppleShop Pop-up Store uses POD-based product production,<br/>allowing you to sell even a single pop-up store product without inventory!",
        mo_ad_description_3:
          "Don't worry! MarppleShop Pop-up Store uses POD-based<br/>product production, allowing you to sell even a single<br/>pop-up store product without inventory!",
        ad_title_4: 'How are you handling<br/>leftover inventory after<br/>your offline pop-up store ends?',
        mo_ad_title_4: 'After the offline pop-up store,<br/>what about leftover inventory?',
        ad_description_4:
          "Are you planning to sell your pop-up store inventory<br/>on second-hand markets or open markets?<br/>Offer a special experience through MarppleShop Pop-up Store<br/>to customers who couldn't visit your offline pop-up store!",
        mo_ad_description_4:
          "Are you planning to sell your pop-up store inventory on second-hand markets or open markets? Offer a special experience through MarppleShop Pop-up Store to customers who couldn't visit your offline pop-up store!",
        statistics_title:
          'MarppleShop is a creator commerce platform<br/>that continues to grow based on<br/>its production expertise!',
        statistics_date: 'As of January 2024',
        statistics_creator_count: 'Active Creators',
        statistics_member_count: 'Members',
        statistics_product_category_count: 'Producible Product Categories',
        statistics_marpple_product_count: 'Products Made by MarppleShop',
        statistics_brand_count: 'Plus Companies / Brands',
        statistics_popupstore_count: 'Pop-up Stores Launched by MarppleShop So Far',
        mo_statistics_title:
          'MarppleShop is a creator<br/>commerce platform that<br/>continues to grow based on<br/>its production expertise!',
        mo_statistics_date: 'As of January 2024',
        mo_statistics_creator_count: 'Active Creators',
        mo_statistics_member_count: 'Members',
        mo_statistics_product_category_count: 'Producible Product Categories',
        mo_statistics_marpple_product_count: 'Products Made by MarppleShop',
        mo_statistics_brand_count: 'Plus Companies / Brands',
        mo_statistics_popupstore_count: 'Launched Pop-up Stores',
        exhibition_title: 'MarppleShop Pop-up Store<br/>created together by<br/>MarppleShop and creators',
        exhibition_description:
          'MarppleShop Pop-up Store is a service where MarppleShop and creators can create and sell products together, with MarppleShop helping with everything from product planning, production, sales, to shipping.',
        exhibition_plan: 'Pop-up Store Planning',
        exhibition_plan_description: 'Plan pop-up store products and content<br/>together with creators.',
        exhibition_produce: 'Planned Product Production',
        exhibition_produce_description:
          'We also produce planned products<br/>rather than just POD, such as limited edition<br/>and special products!',
        exhibition_sale: 'Pop-up Store Sales',
        exhibition_sale_description: 'Sell produced products through<br/>MarppleShop Pop-up Store.',
        exhibition_delivery: 'Shipping and Inventory Management',
        exhibition_delivery_description:
          'MarppleShop handles everything including<br/>shipping, inventory management, and customer service.',
        case_title:
          'Many brands / creators have already<br/>achieved successful results<br/>through MarppleShop Pop-up Store!',
        case_transaction: 'Transaction Amount',
        case_ordered: 'Order Volume',
        case_duration: 'Sales Period',
        case_transaction_a: '2.48 billion KRW',
        case_ordered_a: 'About 77,000 units',
        case_duration_a: '18 days',
        case_transaction_b: '1.49 billion KRW',
        case_ordered_b: 'About 89,000 units',
        case_duration_b: '15 days',
        case_transaction_c: 'About 1 billion KRW',
        case_ordered_c: 'About 56,000 units',
        case_duration_c: '15 days',
        case_transaction_d: 'About 1.65 billion KRW',
        case_ordered_d: 'About 54,000 units',
        case_duration_d: '15 days',
        case_transaction_e: 'About 920 million KRW',
        case_ordered_e: 'About 51,000 units',
        case_duration_e: '11 days',
        portfolio_title: 'MarppleShop X Creator<br/> Pop-up Store Product Portfolio',
        portfolio_description:
          'If you have pop-up store products you want to specially plan<br/>beyond the design products provided by MarppleShop, MarppleShop will help with everything from planning to production!',
        mo_portfolio_description:
          'If you have pop-up store products you want to specially plan<br/>beyond the design products provided by MarppleShop,<br/>MarppleShop will help with everything from planning to production!',
        popup_store_title: 'Diverse Pop-up Stores<br/>Created with MarppleShop',
        popup_store_button: 'View More MarppleShop Pop-up Stores',
        bottom_title: 'Dream Online Pop-up Store,<br/>Create It with MarppleShop!',
        mo_bottom_title: 'Online Pop-up Store,<br/>Create It with<br/>MarppleShop!',
        bottom_button: 'Apply for Online Pop-up Store',
        submit_form_title: 'Apply for MarppleShop Online Pop-up Store',
        submit_form_description: 'Shall we launch a special online pop-up store?',
        submit_form_creator: 'Please enter creator / brand name (required)',
        submit_form_is_creator: 'Are you already a MarppleShop creator?',
        submit_form_is_creator_yes: 'Yes',
        submit_form_is_creator_no: 'No',
        submit_form_domain: 'Domain',
        submit_form_company: 'Please enter company name (optional)',
        submit_form_manager: 'Manager Name (required)',
        submit_form_manager_email: 'Manager Email Address (required)',
        submit_form_manager_phone: 'Manager Contact (numbers only) (required)',
        submit_form_sns:
          'Please enter the address of your SNS channels such as Youtube, Instagram, X(Twitter), etc. (optional)',
        submit_form_file: 'Please attach creator / brand introduction if available (optional)',
        submit_form_other:
          'Please describe products you want to sell at MarppleShop Pop-up Store or proposal details (optional)',
        submit_form_guide:
          'After review by the responsible partner, we will reply within about 5 business days.',
        submit_form_agree: 'Consent to Provide Personal Information',
        submit_form_agree_content:
          '<strong>Purpose of collecting/using personal information:</strong> Identity verification for MarppleShop Pop-up Store service application<br/>Items of personal information collected: Company name, name, email, contact<br/>Retention and use period of personal information: Until the end of the purpose of use',
        submit_form_button: 'Submit Online Pop-up Store Application',
        submit_form_creator_error: 'This domain does not exist. Please check and enter again.',
        submit_form_email_error: 'Please enter a valid email address.',
        submit_form_phone_error: 'Please enter a valid contact number.',
        mo_submit_form_creator: 'Creator / Brand Name (required)',
        mo_submit_form_is_creator: 'Are you a MarppleShop creator?',
        mo_submit_form_domain: 'Domain',
        mo_submit_form_company: 'Company Name (optional)',
        mo_submit_form_manager: 'Manager Name (required)',
        mo_submit_form_manager_email: 'Manager Email Address (required)',
        mo_submit_form_manager_phone: 'Manager Contact (numbers only) (required)',
        mo_submit_form_sns: 'SNS Channel Address (optional)',
        mo_submit_form_file: 'Creator / Brand Introduction (optional)',
        mo_submit_form_other:
          'Please describe products you want to sell at MarppleShop Pop-up Store or proposal details (optional)',
        mo_submit_form_button: 'Submit Application',
        submit_success_modal_title: 'Application Submission Complete',
        submit_fail_modal_title: 'Submission Failed',
        submit_success_modal:
          'Your online pop-up store application<br/>has been successfully submitted.<br/>We will review it quickly and contact you.',
        submit_fail_modal:
          'Due to a system error,<br>your application was not submitted.<br>Please contact partner@marppleshop.com.',
      },
      plus: {
        submit: 'Apply for MarppleShop Plus',
        motion_title: 'The fastest and easiest way<br/>to start IP commerce,<br/>MarppleShop Plus',
        motion_description:
          'A one-stop solution providing all the infrastructure needed for business e-commerce,<br/>from IP commerce platform construction to product production, orders, shipping, and customer service',
        mo_motion_description:
          'A one-stop solution providing<br/>all the infrastructure needed for business e-commerce',
        statistics_title: 'The IP market is evolving<br/>from content to business',
        mo_statistics_title: 'The IP market is<br/>evolving from content<br/>to business',
        statistics_description:
          'Content IP (Intellectual Property) is<br/>being consumed across various channels, creating buzz and trends',
        statistics_chart_title: 'IP commerce is growing<br/>by 30% every year',
        mo_statistics_chart_title: 'IP commerce is<br/>growing by 30% every year',
        statistics_chart_description:
          "The global market size of the 'Character License Sector' encompassing IP commerce<br/>has grown to 330 billion USD (443 trillion KRW)",
        statistics_chart_source: 'Korea Creative Content Agency (2022)',
        statistics_circle_title: 'The domestic fandom economy size is<br/>about 7.9 trillion KRW!',
        statistics_circle_description:
          'Many entertainment companies are<br/>successively entering the IP commerce business',
        statistics_circle_source: 'As of 2022',
        case_title: 'However, IP commerce has increasingly higher barriers.<br/>How are you responding?',
        mo_case_title: 'How are you responding to<br/>IP commerce with increasingly<br/>higher barriers?',
        case_mcn_title: 'MCN Company<br/>Commerce MD',
        case_mcn_description:
          "Content consumption speed is too fast!<br/>We need to produce products quickly to match the content production and consumption cycle,<br/>but there's the burden of MOQ, inventory, and limited products we can make!",
        mo_case_mcn_description:
          "Content consumption speed is too fast!<br/>We need to produce products quickly to match the content<br/>production and consumption cycle, but there's the burden of<br/>MOQ, inventory, and limited products we can make!",
        case_game_title: 'Game Company<br/>New Business Development Team Leader',
        case_game_description:
          'We tried to make goods using our game characters<br/>as a test bed, but the process was too<br/>complicated and difficult. The MOQ was also considerable.<br/>From requesting production to the factory to receiving the finished product,<br/>this whole process was a war in itself!',
        mo_case_game_description:
          'We tried to make goods using our game characters<br/>as a test bed, but the process was too complicated and dif<br/>ficult. The MOQ was also considerable. From requesting pro<br/>duction to the factory to receiving the finished product, this<br/>whole process was a war in itself!',
        case_webtoon_title: 'Webtoon Service<br/>IP Business Team Leader',
        case_webtoon_description:
          "Popular webtoon T-shirts are in constant demand from fans to the point of selling out as soon as they're released, but it's not easy to make goods using materials from over 200 authors and the enormous amount of content that comes with them.",
        mo_case_webtoon_description:
          "Popular webtoon T-shirts are in constant demand from fans<br/>to the point of selling out as soon as they're released, but it's<br/>not easy to make goods using materials from over 200 authors<br/>and the enormous amount of content that comes with them.",
        case_entertain_title: 'Entertainment<br/>CEO',
        case_entertain_description:
          "I'm thinking of creating a goods commerce site for our artists,<br/>but from domain to design to development... there's so much to do to build the platform from scratch that I don't dare to start.",
        mo_case_entertain_description:
          "I'm thinking of creating a goods commerce site for our ar<br/>tists, but from domain to design to development... there's so<br/>much to do to build the platform from scratch that I don't<br/>dare to start.",
        case_creator_title: 'Creator Company<br/>CS Manager',
        case_creator_description:
          "As the products sold vary depending on the company's creators, customers' needs are diverse and requirements are complex, making each solution process cumbersome and difficult to respond to.",
        mo_case_creator_description:
          "As the products sold vary depending on the company's cre<br/>ators, customers' needs are diverse and requirements are com<br/>plex, making each solution process cumbersome and difficult<br/>to respond to.",
        commerce_title: 'IP Commerce, No More<br/>Worries!',
        commerce_description:
          'Through MarppleShop Plus, you can save time and costs needed for brand commerce —<br/>from product development to production and quality control,<br/>inventory and logistics management, platform construction and operation.',
        mo_commerce_description:
          'In addition to the design products provided by MarppleShop,<br/>if you have pop-up store products you want to specially plan,<br/>MarppleShop will help with everything from planning to production!',
        commerce_product: 'Product Development',
        commerce_quality: 'Quality Control',
        commerce_platform: 'Platform Construction and Operation',
        commerce_sale: 'Product Sales',
        commerce_inventory: 'Inventory and Logistics Management',
        commerce_delivery: 'Shipping, Operation, and Customer Service',
        exhibition_title: 'With MarppleShop Plus,<br/>easily produce over 1,200 types of products!',
        exhibition_description:
          "Start a new business with MarppleShop Plus, which has<br/>developed Korea's first online IP commerce solution and has a one-stop solution<br/>from product production to order, shipping, and customer service.",
        mo_exhibition_title: 'With MarppleShop Plus,<br/>easily produce<br/>over 1,200 types of products!',
        mo_exhibition_description:
          "Start a new business with MarppleShop Plus,<br/>which has developed Korea's first online IP commerce solution<br/>and has a one-stop solution from product production<br/>to order, shipping, and customer service.",
        ad_title_1: 'Amazing Product Quality and<br/>Drop Shipping Service!',
        ad_description_1:
          'MarppleShop Plus promises top-quality product production,<br/>easy inventory management through Drop Shipping Service<span>*</span>,<br/>and shipping.',
        ad_guide_1:
          'Drop Shipping Service is an order processing method where sellers do not manage product inventory at all,<br/>but sell and ship to customers through a company.',
        ad_title_2: 'Build Corporate Brand Commerce<br/>Platforms<br/>Easily!',
        ad_description_2:
          'The e-commerce platform can be customized for businesses,<br/>and individual affiliated seller stores can be<br/>created at once and managed easily.',
        ad_title_3: 'E-commerce Solutions for<br/>Self-produced 3P Products<br/>Are Also Possible!',
        ad_description_3:
          'We provide a process that allows you to easily register products,<br/>sell, and ship self-produced 3P products.',
        ad_title_4: 'We Provide<br/>Commerce Operation and<br/>Customer Service',
        ad_description_4:
          'MarppleShop Plus provides all operational processes<br/>for complex and difficult online commerce, including customer consulting,<br/>product inquiries, returns, and exchange guidance.',
        mo_ad_title_1: 'Amazing Product Quality and<br/>Drop Shipping Service!',
        mo_ad_title_2: 'Build Corporate Brand Commerce<br/>Platforms Easily!',
        mo_ad_title_3: 'E-commerce Solutions for<br/>Self-produced 3P Products Possible!',
        mo_ad_title_4: 'Commerce Operations and<br/>Customer Service All Provided!',
        solution_title:
          'MarppleShop Plus Also<br/>Provides Customized Management Solutions<br/>for Businesses',
        solution_description:
          'Through the management page, all functions necessary for commerce operation are provided,<br/>from easy data analysis to administrator permission settings,<br/>settlement, product management, etc.',
        solution_report: 'Data Analysis and<br/>Reports',
        solution_store: 'Store and<br/>Product Management',
        solution_creator: 'Creator<br/>Management',
        solution_ecommerce: '3P E-commerce<br/>Management',
        solution_site: 'Site and<br/>Page Management',
        solution_manage: 'Administrator and<br/>Manager Permission Management',
        portfolio_title:
          'Many Companies / Brands Are Already<br/>Using MarppleShop Plus to<br/>Realize IP Business',
        portfolio_description:
          'From MCN companies with numerous creators, to content companies with various IPs,<br/>to companies developing various projects —<br/>they are easily realizing IP business using MarppleShop Plus.',
        mo_portfolio_title: 'Many Companies / Brands Are<br/>Realizing IP Business<br/>With MarppleShop Plus',
        mo_portfolio_description:
          'From MCN companies with numerous creators,<br/>to content companies with various IPs, to companies<br/>developing various projects — they are easily<br/>realizing IP business using MarppleShop Plus.',
        portfolio_button: 'MarppleShop Plus Portfolio',
        bottom_title: "If you have your company's IP content,<br/>start your IP business!",
        mo_bottom_title: "If you have<br/>your company's IP content,<br/>start your IP business!",
        plus_apply: 'Apply for MarppleShop Plus',
        submit_form_title: 'Apply for MarppleShop Plus',
        submit_form_description:
          'If you are a company/brand with various IP content, please apply for MarppleShop Plus.',
        submit_form_company: 'Company Name',
        submit_form_company_category: 'Company Type',
        submit_form_manager: 'Manager Name',
        submit_form_manager_email: 'Manager Email Address',
        submit_form_manager_phone: 'Manager Contact (numbers only)',
        submit_form_file: 'Company Introduction (optional)',
        submit_form_other:
          'Please describe your IP content and business proposals you would like to pursue with MarppleShop Plus. (optional)',
        submit_form_agree: 'Consent to Provide Personal Information',
        submit_form_agree_content:
          '<strong>Purpose of collecting/using personal information:</strong> Identity verification for MarppleShop Plus service application<br/>Items of personal information collected: Company name, name, email, contact<br/>Retention and use period of personal information: Until the end of the purpose of use',
        submit_form_marketing: 'Consent to Use for Promotional Marketing (optional)',
        submit_form_marketing_content:
          'Assets registered with MarppleShop may be used for promotional marketing purposes.',
        submit_form_button: 'Submit MarppleShop Plus Application',
        submit_form_email_error: 'Please enter a valid email address.',
        submit_form_phone_error: 'Please enter a valid contact number.',
        submit_form_guide:
          'After review by the responsible partner, we will reply within about 5 business days.',
        mo_submit_form_company: 'Company Name',
        mo_submit_form_manager: 'Manager Name',
        mo_submit_form_manager_email: 'Manager Email Address',
        mo_submit_form_manager_phone: 'Manager Contact (numbers only)',
        mo_submit_form_file: 'Company Introduction (optional)',
        mo_submit_form_other:
          'Please describe your IP content and business proposals you would like to pursue with MarppleShop Plus. (optional)',
        mo_submit_form_button: 'Submit Application',
        submit_success_modal_title: 'Application Submission Complete',
        submit_fail_modal_title: 'Submission Failed',
        submit_success_modal:
          'Your MarppleShop Plus application<br/>has been successfully submitted.<br/>We will review it quickly and contact you.',
        submit_fail_modal:
          'Due to a system error,<br>your application was not submitted.<br>Please contact partner@marppleshop.com.',
        enterprise_category: 'Company Type',
        private_enterprise: 'Sole Proprietorship',
        corporate_enterprise: 'Corporation',
        public_enterprise: 'Public Enterprise',
        social_enterprise: 'Social Enterprise',
        etc_enterprise: 'Other',
      },
      handmade: {
        scale_title: 'You too, a handmade creator <br /> with burning passion',
        mo_scale_title: 'You too, <br /> a handmade creator <br /> with burning passion',
        scale_description: 'Now at MarppleShop',
        craft_title_1: 'HOME DECO AND LIVING <br /> HANDMADE CREATOR',
        craft_title_2: 'JEWELRY AND ACCESSORIES <br /> HANDMADE CREATOR',
        craft_title_3: 'EMBROIDERY AND KNITTING <br /> HANDMADE CREATOR',
        craft_description_1: 'You with soft and warm <br /> passion',
        craft_description_2: 'You with fiery hot <br/> passion',
        craft_description_3: 'You with persistent <br /> stitch-by-stitch passion',
        video_card_title_1: 'Make everything you can imagine <br /> a reality at MarppleShop',
        mo_video_card_title_1: 'At MarppleShop, <br /> make everything you <br /> can imagine a reality',
        video_card_title_2:
          'The moment your precious hobby becomes <br /> a work of art and shines in the world',
        mo_video_card_title_2:
          'The moment <br /> your precious hobby becomes a work <br /> of art and shines in the world',
        video_card_title_3: 'At the moment your dream becomes reality, <br /> MarppleShop is always with you',
        mo_video_card_title_3:
          'At the moment <br /> your dream becomes reality, <br /> MarppleShop is always with you',
        links_title: 'Handmade Creators, <br />Why MarppleShop?',
        links_card_title_1: 'Create your own brand shop, <br /> really easily',
        links_card_description_1:
          'To make your handmade creations stand out, <br />\n           create your own brand shop on MarppleShop. <br />\n           With simple settings, you can easily open your shop <br />\n           and display and sell handmade products. <br />\n           Set logos, banner images, detail pages freely <br />\n           to make your creative world stand out even more!',
        mo_links_card_description_1:
          'To make your handmade creations stand out, <br />\n         create your own brand shop on MarppleShop. <br />\n         With simple settings, you can easily open your shop <br />\n         and display and sell handmade products.',
        mo_links_card_sub_description_1:
          'Set brand logos, banner images, detail pages freely <br />\n         to make your creative world stand out even more!',
        links_cta_button_text_1: 'View Handmade/DIY Products',
        links_card_title_2: 'Increase your sales revenue <br />with MarppleShop-produced products.',
        links_card_description_2:
          "With just a design, you can sell MarppleShop-produced products that support the entire process from production to packaging, shipping, customer service, and inventory management. <br /> You can easily sell products you've designed without worrying about complex logistics management or production processes. <br /> We'll help you focus solely on your creative activities.",
        mo_links_card_description_2:
          'With just a design, you can sell MarppleShop-produced <br /> products that support the entire process from production to <br /> packaging, shipping, customer service, and inventory management.',
        mo_links_card_sub_description_2:
          "You can easily sell products you've designed without <br /> worrying about complex logistics management or production processes. <br /> We'll help you focus solely on your creative activities.",
        links_cta_button_text_2: 'View Merchandise Products',
        links_card_title_3: "MarppleShop is Korea's first<br />official YouTube Shopping partner",
        links_card_description_3:
          "MarppleShop is Korea's first official YouTube Shopping partner. <br /> Through integration with various SNS channels like YouTube and Instagram and your brand shop, <br /> fans can find your products anywhere. <br /> Use YouTube Shopping features to connect video content <br /> with product purchases for a more vibrant customer experience.",
        mo_links_card_description_3:
          "MarppleShop is Korea's first official YouTube Shopping partner. <br /> Through integration with various SNS channels like YouTube <br /> and Instagram and your brand shop, fans can find <br /> your products anywhere.",
        mo_links_card_sub_description_3:
          'Use YouTube Shopping features to connect video content <br /> with product purchases for a more vibrant customer experience.',
        links_cta_button_text_3: 'What is MarppleShop X YouTube Shopping?',
        links_card_title_4: 'From selling patterns with your know-how <br /> to selling e-books',
        links_card_description_4:
          'At MarppleShop, in addition to physical products, you can sell <br /> digital patterns or e-books full of your own know-how. <br /> You can generate income from digital/e-books through handmade <br /> by selling digital content containing your creative know-how.',
        mo_links_card_description_4:
          'At MarppleShop, in addition to physical products, you can sell digi <br /> tal patterns or e-books full of your own know-how. <br /> You can generate income from digital/e-books through hand <br /> made by selling digital content containing your creative know-how.',
        links_cta_button_text_4: 'View Digital/E-book',
        links_card_title_5: 'Open a unique pop-up store <br /> with your precious works',
        links_card_description_5:
          "MarppleShop operates an offline pop-up store space <br /> in Seongsu-dong, the mecca of pop-up stores. <br /> MarppleShop's pop-up store is equipped with <br /> sophisticated fixtures and an easy, simple sales system <br /> so creators can focus solely on creation and product sales.",
        mo_links_card_description_5:
          'MarppleShop operates an offline pop-up store space <br /> in Seongsu-dong, the mecca of pop-up stores.',
        mo_links_card_sub_description_5:
          "MarppleShop's pop-up store is equipped with <br /> sophisticated fixtures and an easy, simple sales system <br /> so creators can focus solely on creation and product sales.",
        links_cta_button_text_5: 'What is MarppleShop Pop-up Store?',
        statistics_date: 'Data as of October 2024',
        statistics_title_1: 'Active Creators',
        statistics_title_2: 'Top 15% Monthly Average Income',
        statistics_title_3: 'Cumulative Transaction Amount',
        statistics_title_4: 'Member Count',
        statistics_title_5: 'Repurchase Rate',
        statistics_title: 'MarppleShop is <br /> a continuously growing <br /> creator commerce platform',
        statistics_description:
          "Create your own brand and realize your ideas on MarppleShop. <br /> On MarppleShop, you can sell everything from handmade products you've created to merchandise and digital/e-books.",
        mo_statistics_description:
          "Create your own brand and realize <br /> your ideas on MarppleShop. <br /> On MarppleShop, you can sell everything from handmade <br /> products you've created to merchandise and digital/e-books.",
        statistics_button: 'Make it reality, MarppleShop',
        portfolio_banner_title: 'MarppleShop stories of passionate<br/> handmade creators like you',
        mo_portfolio_banner_title: 'MarppleShop stories of<br/> passionate handmade<br/> creators like you',
        interview_title:
          'Thanks to MarppleShop, <br />I was able to showcase my work <br />to customers more quickly',
        interview_sub_title: 'Hear directly about the changes<br />MarppleShop has brought to creators.',
        interview_description:
          "Check out creators' stories about how they grew their brands through MarppleShop,<br /> what experiences they had while sharing handmade works with the world.<br /> MarppleShop provides special opportunities for you too.",
        interview_creator_1: 'Resin Art Brand<br /> Small Village',
        interview_sub_description_1:
          "These days, it's difficult for people to have special hobbies while being exposed to various media.<br/> I want to sell various kits that even resin craft beginners can easily make.",
        interview_description_1:
          "Customers could conveniently purchase with orders available on YouTube, and it's a great advantage that viewers interested in crafts can watch videos and immediately purchase necessary materials.<br/> Furthermore, I want to start international shipping. As K-culture trends, foreign viewers on our YouTube channel have increased.<br/> If international shipping is possible through MarppleShop, it would be a great help.",
        interview_creator_2: 'Lifestyle Brand<br/>DDUKATTA',
        interview_sub_description_2:
          "I want to promote the brand 'DDUKATTA' through MarppleShop and deliver new experiences through various works. Also, I hope that through MarppleShop,<br/> opportunities for collaboration with creators from different fields<br/> and new experimental challenges will arise.",
        interview_description_2:
          "The Seongsu-dong pop-up store and online shop operation were convenient, and proceeded smoothly thanks to MarppleShop's various supports.<br/> The experience of one-stop support from product production to marketing and pop-up was good, and I could save time and cost<br/> because of the MarppleShop-produced products that allow easy production and sales without inventory burden.",
        interview_creator_3: 'Textile Craft Brand<br/>Kunst Heute',
        interview_sub_description_3:
          "It seems like a good opportunity to understand<br/> what customers want and how they live when connecting crafts and goods.<br/> I want to showcase products designed and produced by understanding MarppleShop customers' needs,<br/> utilizing the characteristics of crafts with various works<br/> containing Kunst Heute's natural colors and dyeing techniques.",
        interview_description_3:
          'In particular, I think MarppleShop is optimized for creating<br/> one-of-a-kind items as it has high potential for developing<br/> in the form of collaboration with customers. It matches well with the direction<br/> Kunst Heute pursues, and I expect it will lead to new synergy.',
        benefit_title: 'MarppleShop, Now is the Opportunity',
        benefit_description:
          'MarppleShop has prepared special benefits for handmade creators. <br />Showcase your work to more fans through MarppleShop!',
        mo_benefit_description: 'MarppleShop has prepared special benefits <br /> for handmade creators.',
        benefit_card_title_1: '0% Store Entry Sales Commission',
        mo_benefit_card_title_1: 'Store Entry Sales Commission 5% → 0%',
        benefit_card_sub_description_pc_1: '※ PG company fee (3.52%) is separate.',
        benefit_card_sub_description_pc_2:
          '※ MarppleShop commission policy is subject to change at any time.',
        benefit_card_sub_description_1: '※ PG/Card company fees excluded',
        benefit_card_title_2: 'Offline Pop-up Store Support',
        mo_benefit_card_title_2: 'Offline Pop-up Store Support',
        benefit_card_description_2:
          'Open your own pop-up at the <span>MarppleShop offline pop-up store</span>. <br /> Increase your sales by expanding from handmade products to merchandise. <br /> MarppleShop helps you succeed from <span>product planning to pop-up planning and VMD</span>.',
        mo_benefit_card_description_2:
          'Open your own pop-up at the<br /> <span>MarppleShop offline pop-up store</span>.<br /> Increase your sales by expanding<br /> from handmade products to merchandise.<br /> MarppleShop helps you succeed from<br /> <span>product planning to pop-up planning and VMD</span>.',
        benefit_card_sub_description_2: 'View Offline Pop-up Store Cases',
        benefit_card_title_3: 'Advertising and Promotion Support',
        mo_benefit_card_title_3: 'Advertising and Promotion Support',
        benefit_card_description_3:
          "We provide handmade creators who join during the campaign period<br /> with opportunities to participate in the <span>MarppleShop online pop-up store</span>.<br /> Run an online pop-up store based on storytelling suitable for handmade items<br /> to effectively expose your brand and products.<br /> We support active promotion through <span>MarppleShop's onsite and SNS channels</span>.",
        mo_benefit_card_description_3:
          "We provide handmade creators who join during the campaign period with opportunities to participate in the <span>MarppleShop online pop-up store</span>.<br /> Run an online pop-up store based on<br /> storytelling suitable for handmade items to effectively<br /> expose your brand and products.<br /> We support active promotion through<br /> <span>MarppleShop's onsite and SNS channels</span>.",
        benefit_card_sub_description_3: 'View Online Pop-up Store Cases',
        benefit_card_title_4: 'YouTube Shopping Support',
        mo_benefit_card_title_4: 'YouTube Shopping Support',
        benefit_card_description_4:
          'Do you also operate a YouTube channel? <br /> For creators who meet YouTube monetization requirements, <br /> you can use <span>YouTube Shopping features by linking with MarppleShop</span>. <br /> Connect products to your content to provide customers with a special shopping experience.',
        mo_benefit_card_description_4:
          'Do you also operate a YouTube channel?<br /> For creators who meet YouTube monetization requirements,<br /> you can use <span>YouTube Shopping features</span><br /> <span>by linking with MarppleShop</span>.<br /> Connect products to your content to provide customers<br /> with a special shopping experience.',
        benefit_card_sub_description_4: 'What is MarppleShop X YouTube Shopping?',
        benefit_info_title: 'Benefit Reference Information',
        benefit_info_desc_1:
          'The availability of online/offline pop-up stores is determined by space rental schedules and MarppleShop review.',
        benefit_info_desc_2:
          'For YouTube Shopping, it can be utilized after meeting YouTube monetization requirements and going through the MarppleShop creator approval process.',
        story_nav_1: '1. Starting from Fingertips',
        story_nav_2: '2. With Sincerity and Love',
        story_nav_3: '3. Same Dream',
        story_nav_4: "4. Someone's Daily Life",
        story_nav_5: '5. With MarppleShop',
        story_title: 'With MarppleShop, <br /> The Special Story My Work Tells',
        mo_story_title: 'With MarppleShop, <br /> The Special Story <br /> My Work Tells',
        story_content_title_1: 'A Story That Begins at My Fingertips',
        story_content_description_1:
          "Each work I create warms someone's heart. <br /> You who made that one-of-a-kind special item yourself, share that sincerity and story with more people. <br /> MarppleShop helps your small creative moments become greater joy <br /> and meet more people.",
        mo_story_content_description_1:
          "Each work I create warms<br /> someone's heart.<br /> You who made that one-of-a-kind special item yourself,<br /> share that sincerity and story with more people.<br /> MarppleShop helps your small creative moments become greater joy<br /> and meet more people.",
        story_content_link_1: 'View Handmade/DIY Products',
        story_content_title_2: 'Works Completed with Sincerity and Love',
        story_content_description_2:
          "Works made with care one by one at the fingertips, they are filled with the creator's love and passion. <br /> MarppleShop does its best to support creators' works to shine more. <br /> We will be with you as your works permeate into more people's daily lives, creating precious moments.",
        mo_story_content_description_2:
          "Works made with care one by one at the fingertips, <br /> they are filled with the creator's love and passion. <br /> MarppleShop does its best to support <br /> creators' works to shine more. <br /> We will be with you as your works permeate into more people's daily lives, <br /> creating precious moments.",
        story_content_link_2: 'Handmade/DIY Curation',
        story_content_title_3: 'Meeting People with the Same Dream',
        story_content_description_3:
          "MarppleShop has creators who dream the same dream. <br /> At MarppleShop, where we cheer for each other's passion and grow by exchanging inspiration, <br /> we become one community. <br /> Share your creative story with us and make a better world.",
        mo_story_content_description_3:
          "MarppleShop has creators who dream the same dream. <br /> At MarppleShop, where we cheer for each other's passion and grow by exchanging inspiration, <br /> we become one community. <br /> Share your creative story with us and make a better world.",
        story_content_link_3: 'Creator Community',
        story_content_title_4: "Your Work Brings Specialness to Someone's Daily Life",
        story_content_description_4:
          'That special work born from your fingertips can be a small daily happiness for someone. <br /> MarppleShop supports your journey of creating those moments together. <br /> We will be with you throughout the entire creative process, so your efforts lead to beautiful results.',
        mo_story_content_description_4:
          'That special work born from your fingertips can be <br /> a small daily happiness for someone. <br /> MarppleShop supports your journey of creating those moments together. <br /> We will be with you throughout the entire creative process, <br /> so your efforts lead to beautiful results.',
        story_content_link_4: 'Handmade Reviews',
        story_content_title_5: 'More Opportunities with MarppleShop',
        story_content_description_5:
          'Start your story on MarppleShop.<br />With various benefits and support upon joining, you can reach more fans and achieve greater possibilities.<br />Begin your new challenge at MarppleShop, the stage to realize your creative dreams.',
        mo_story_content_description_5:
          'Start your story on MarppleShop.<br />With various benefits and support upon joining,<br />you can reach more fans and achieve greater possibilities.<br />Begin your new challenge at MarppleShop,<br />the stage to realize your creative dreams.',
        story_content_link_5: 'Apply as Creator',
        bottom_title: 'Thanks to our creators,<br />the world becomes warmer and happier.',
        mo_bottom_title: 'Thanks to our creators,<br />the world becomes warmer<br />and happier.',
        bottom_description:
          "From small gifts for loved ones to events and special anniversaries,<br />MarppleShop respects the values handmade delivers and<br />will consistently strive to support handmade creators' growth.",
        mo_bottom_description:
          "From small gifts for loved ones<br />to events and special anniversaries—<br />MarppleShop respects the values handmade delivers and<br />will consistently strive to support<br />handmade creators' growth.",
      },
    },
  },
  콘텐츠: 'Contents',
  의류: 'Apparel',
  스포츠: 'Sports',
  굿즈: 'Goods',
  스티커: 'Sticker',
  패션잡화: 'Accessories',
  '토이/취미': 'Toy/Hobby',
  '쿠션/패브릭': 'Fabric',
  '폰 악세서리': 'Phone ACC',
  '문구/오피스': 'Stationery',
  키즈: 'Kids',
  애견: 'Pet',
  리빙: 'Living',
  '디지털/전자책': 'Digital/E-book',
  액자: 'Frames',
  '도서/음반': 'Books/Recordings',
  핸드메이드: 'Handmade/DIY',
  식품: 'Food',
  withdrawal: {
    title: 'Delete account',
    '고객님 마플샵을 정말 탈퇴하시나요?': 'Are you really leaving the Marpple or MarppleShop? 😢',
    '회원 탈퇴 전 아래 사항을 숙지해 주세요.':
      'Before deleting your account, please be aware of the following.',
    description_1:
      'If you are a regular member, you can rejoin after deleting your account, but all information, including purchases, order history, points, and any active membership subscriptions, will be deleted.',
    description_2:
      'If you are a MarppleShop Creator, you can delete your account only when there are <b>no ongoing transactions, your remaining earnings are zero, and there are no active memberships for sale.</b> Deletion is allowed only after all shipments, customer service, and settlements are completed. All account information, including your shop and sales history, will be permanently deleted and cannot be restored.',
    description_3:
      "Even after deleting your account, purchased items will still be shipped, and your personal information will be protected according to Marpple and Marppleshop's policy and relevant laws for product returns and customer service.",
    description_4:
      'For assistance, please contact our customer center at 1566-5496 or cs@marpple.com for assistance.',
    '진행 중인 거래': 'Ongoing Transactions',
    몇건: '{{count}}transactions',
    '잔여 수익 금액': 'Remaining Earnings',
    몇원: 'KRW {{amount}}',
    '보유 포인트': 'Remaining Points',
    몇포인트: '{{point}}P',
    그동안:
      'Thank you for using MCO.<br/>We will strive to welcome you back with even better service in the future.',
    취소: 'Cancel',
    탈퇴하기: 'Delete account',
    '정말 탈퇴하시겠어요?': 'Are you sure you want to delete your account?',
    '모든 회원 정보는 즉시 삭제': 'All account information will be deleted and cannot be restored. Proceed?',
    네: 'Yes',
    실패: 'Failure',
    '회원 탈퇴 완료': 'Account deleted',
    '회원 탈퇴 불가': 'Account deletion failed',
    '진행 중인 거래 0건':
      'You can only delete your account when there are no ongoing transactions and remaining earnings are zero. For more details, please check on MarppleShop Studio. For assistance, please contact us at <a href="tel:{{tel}}" style="color: #1C75FF;" >{{tel}}</a> or <a href="mailto:{{email}}" style="color: #1C75FF;">{{email}}</a>, and we will assist you',
    alert_content:
      'Thank you for using MCO.<br/>We will strive to welcome you back with even better service in the future.',
    membership: 'Memberships for sale',
    몇개: '{{count}}Plans',
  },
  maker: {
    icon: {
      custom_asset: 'Custom Asset',
      status_txt1: 'Collections in use',
      custom_user_asset: 'Custom User Asset',
    },
  },
  labs: {
    setting: {
      info: 'It may take some time for the character settings to be reflected in the product.',
    },
    my_characters: {
      desc: '캐릭터 선택창 액자와 함께 구매할 내 캐릭터를 선택해주세요. (최대 10개까지 선택 가능)',
      desc_mo: '캐릭터 선택창 액자와 함께 구매할 내 캐릭터를 선택해주세요.<br />(최대 10개까지 선택 가능)',
      alert: {
        alert_1: '캐릭터는 최대 10개까지선택 할 수 있어요.',
        alert_1_mo: '캐릭터는 최대 10개까지 <br />선택 할 수 있어요.',
      },
    },
    main: {
      login_1: '나만의 메이플스토리를 구매하기 위해서는',
      login_2: '로그인이 필요해요!',
      login_3: '로그인하러가기 →',
      no_chracter_1: '고객님의 메이플스토리 캐릭터가 존재하지 않아요!',
      no_chracter_2: '넥슨 계정 확인 후 다시 시도해 주세요.',
      change_button: '캐릭터 감정 / 모션 바꾸기',
      no_chracter_1_1: "We couldn't retrieve your MapleStory character information!",
    },
    error: {
      collabo_1:
        '콜라보 아이템 착용으로 캐릭터가 로드되지 않았습니다.<br />상품을 구매하기 위해 콜라보 아이템 해제 후 아래의 버튼을 눌러주세요!',
      reload: '캐릭터 리로드',
      title: '콜라보 아이템 로드 불가',
      message:
        '고객님의 일부 캐릭터 정보를 불러오지 못하였습니다.<br />\n 콜라보 아이템을 해제한 후 다시 시도해 주세요.',
      item_name: '아이템명',
      notice:
        '지속적으로 동일한 문제 발생 시 1566-7960 혹은<br/><span style="text-decoration: underline; text-decoration-skip-ink : none; text-underline-position :from-font ">nexon@marpple.com</span>으로 문의 바랍니다.',
      special_world: {
        title: '스페셜 월드 캐릭터 로드 불가',
        message: '스페셜 월드의 캐릭터는 불러올 수 없어요.',
        name: '캐릭터명',
      },
      character_load: {
        title: '캐릭터 로드 실패',
        message_1: '고객님의 메이플스토리 캐릭터 정보를 불러 올 수 없습니다.',
        message_2: '캐릭터 정보 확인 후 재시도 해주세요.',
      },
    },
    reload: {
      message: '최근 접속 기준 최대 50개의 캐릭터가 노출됩니다.',
      button: '캐릭터 리로드',
    },
    can_not_load: {
      title: '캐릭터 로드 불가',
      message:
        '마지막 접속일이 23년 12월 21일 이후인 캐릭터만 불러올 수 있습니다.<br />캐릭터를 로드하시려면 게임에 접속해주세요',
      last_date: '마지막 접속일',
    },
    character_not_selected: {
      message: '캐릭터 선택을 위해<br/>LABS 홈으로 이동합니다.',
    },
  },
  admin: {
    in_review_title: 'Creator Screening\t',
    in_review_desc:
      'This is a review page where you can evaluate pending applicants and approve or reject them.',
  },
  creator_shop: {
    section_title: {
      products: 'Goods',
      reviews: 'Reviews',
      fundings: 'Funding',
      goods_products: 'Goods',
      handmade_products: 'Handmade',
      brand_deal_products: 'Brand deal',
      ebook_products: 'E-Book',
    },
    fan_letters: {
      title: 'Fan Letter',
      placeholder_pc_login: 'Send a heartfelt fan letter&#13;&#10;to your favorite creator!',
      placeholder_pc_logout:
        'You can write a fan letter after logging in.&#13;&#10;Log in and share your message!',
      placeholder_mo_login:
        'You can write a fan letter after logging in.&#13;&#10;Log in and share your message!',
      placeholder_mo_logout: 'Log in to send a heartfelt fan letter!',
      pd_title:
        '<span class="pd-contents__fan-letter-preview-blue">{{like_count}}</span>&nbsp;fans are cheering now!</span>',
      pd_title_zero: 'Fans are cheering for the creator!',
      pd_title_02: "'s Fan Letter",
      replies: '{{comment_count}} comments',
      write: 'Send a Fan Letter',
      fake: {
        nickname1: 'Sparkling Myluv',
        body1: 'My inspiring creator!<br />Thanks to you, every day shines brightly!',
        nickname2: 'Cheering Myluv',
        body2: 'Thanks to my favorite, the world is beautiful!<br />I’ll always support you. Love you!',
        nickname3: 'Excited Myluv',
        body3: 'I love it so much I keep coming back!<br />Thank you for your always exciting works!',
      },
      hidden_user: 'Deactivated Account',
    },
    creator_notes: {
      title: "Creator's Note",
    },
    profile: {
      fan: 'Fan',
      become: 'Become a fan',
      became: 'Fanning',
      expand_more: 'See more',
      expand_less: 'Show less',
      popular_title: 'Ranking',
      popular_title_mo: 'Ranking',
      rank: '{{- rank}}<span class="{{klass}}"></span>',
    },
    common: {
      all_count: 'Total {{-count_text}}',
    },
    home: {
      title: 'Home',
    },
    sns_icon: {
      youtube: 'Youtube',
      instagram: 'Instagram',
      grafolio: 'Grafolio',
      facebook: 'Facebook',
      twitch: 'Twitch',
      twitter: 'Twitter',
      x: 'X',
      comic_naver: 'Naver Webtoon',
      kakao_page: 'KakaoPage',
      daum_webtoon: 'Daum Webtoon',
      blog: 'Naver Blog',
      ticktok: 'TikTok',
      behance: 'Behance',
      brunch: 'Brunch',
      spooncast: 'Spooncast',
      daum_cafe: 'Daum Cafe',
      chzzk: 'CHZZK',
      afreecatv: 'AfreecaTV',
      ciety: 'CIETY',
      website: 'Website',
    },
    creator_main_banner: {
      ranking_unit: 'No.',
      see_more: 'See more',
      the_other_links: 'and {{count}} more link',
      profile_edit: 'Edit profile',
      monthly_ranking: '{{month}} ranking No.{{ranking}}',
      weekly_ranking: '{{month}}, week {{week}} ranking No.{{ranking}}',
      realtime_ranking: 'Real-time ranking No.{{ranking}}',
    },
    home_modal: {
      monthly_ranking: 'Monthly ranking No.{{ranking}}',
      weekly_ranking: 'Weekly ranking No.{{ranking}}',
      realtime_ranking: 'Real-time ranking No.{{ranking}}',
      monthly_recorded_at: '{{month}}/{{year}}',
      weekly_recorded_at: '{{month}}/{{year}},Week {{week}}',
      realtime_recorded_at: 'Updated {{minute}} minutes ago',
    },
    fan_service: 'Fan Service',
    lnb_creator_shop: {
      shophome: 'Home',
      funding: 'Funding',
      goods: 'Goods',
      handmade: 'Handmade',
      branddeal: 'Brand deal',
      ebook: 'E-Book',
      membership: 'Membership',
      commission: 'Commission',
      support: 'Donation',
      fanletter: 'Fan Letter',
      review: 'Reviews',
    },
    banner_and_profile_edit_modal: {
      banner_and_profile_edit: 'Change Banner & Profile',
      mo_banner_image_upload_description: '3:2 ratio | Min width 750px | JPG, JPEG, PNG | Max 1MB',
    },
    realtime_ranking: 'Real-time ranking',
  },
  shipping_guide: {
    departure_date_info: 'Shipping Departure Date Information',
    departure_date_info_marpple_desc1:
      'When ordering MarppleShop Delivery products and MarppleShop Production products together, shipping fees are charged only once.',
    departure_date_info_marpple_desc2:
      'If the shipping departure dates for ordered items differ, they will be shipped according to the latest date.',
    departure_date_info_marpple_desc3:
      'Pre-order products may have delayed shipping, so it is recommended to order them separately from other products.',
  },
  cta: {
    coming_soon: 'launch',
    limited: 'Buy Limited Edition',
    limited_not_show_count: 'Buy Limited Edition',
    quantity: '{{quantity}} left',
    membership: 'Join Membership and Purchase',
    limited_sold_out: 'Sales Have Ended!',
    sold_out: 'Sold Out!',
    dtg: 'Available for Purchase on PC!',
    membership_app: 'Please sign up for the membership on PC first.',
    remain_days: '{{days}}days',
    remain_time: '<span>{{days}}</span><span>{{hours}}:{{minutes}}:{{seconds}}</span><span>left!</span>',
    remain_time_coming_soon: '<span>{{days}}</span><span>{{hours}}:{{minutes}}:{{seconds}} until</span>',
  },
  브랜드딜: 'Brand Deal',
  cast_on_air: {
    creator_on_air: 'Creator On Air',
  },
  settings_arrangement: {
    goods: 'Goods',
    handmade: 'Handmade',
    brand_deal: 'Brand deal',
    ebook: 'E-Book',
    page_title: 'Sort Order',
    description: 'Drag and drop to change the order.',
  },
  studio_kakao: {
    studio_usage_inquiry: 'Studio Usage Inquiry',
    operation_know_how: 'Shop Operation Guide',
  },
  studio_quick_guide: {
    studio_first_banner: {
      title: 'Join Marppleshop Mate',
      description: 'Marppleshop will take care of</br>your shop marketing',
    },
    offline_popup_store: {
      title: 'Offline Pop-up Store',
      description: 'Host your own space<br />in Seongsu',
    },
    youtube_shopping: {
      title: 'YouTube Shopping',
      description: 'Host your own space<br />in Seongsu',
    },
    additional_fee_closed: {
      title: 'Marpple Shop Production & Delivery Product\nAdditional Revenue Closed',
      description: 'Applied to sales from November 1st.',
    },
    additional_fee_change: {
      title: 'Operating Policy Change Notice',
      description:
        'Additional revenue for Marpple Shop Production & Delivery products<br/> will be discontinued (Applied to sales from November 1st)',
    },
  },
  ad_res_finish_page: {
    kakao_guide: {
      description:
        'Add our Kakao Channel to get the latest updates on creator activities<br />— service news, new features, product information, and growth tips.',
      button_40_text: 'Add Now',
      description_mo: 'Be the first to catch creator updates<br /> and growth tips on our Kakao Channel.',
      button_40_text_mo: 'Add Now',
    },
  },
  curation: {
    gnb: {
      menu_title: 'Curation',
    },
    curation_list: {
      sub_copy_text: 'Trending picks by MarppleShop',
      main_copy_text: 'Curation',
    },
    main_page_curation_list_view: {
      section_title_text: 'Curation',
      see_more: 'More',
    },
    curation_detail_page: {
      related_products: 'Related Products',
      section_title: 'Latest Curation',
      section_control_text: 'More',
      button_text: 'More',
    },
    latest_curation_feed_page: {
      detached_tab_text: 'More',
      curation_products_text: 'Related Products',
      section_title: 'Latest Curation',
      button_text: 'More',
    },
  },
  card_product: {
    badge_main: {
      trend: 'Trending',
      popular: 'Popular',
      stock_left: '{{count}} Left',
      time_left_until_end: 'Until',
      time_left_seconds: '{{seconds}}s',
      time_left_minutes: '<span>{{minutes}}</span><span>m left</span>',
      time_left_hours: '<span>{{hours}}</span><span>h left</span>',
      days_left: '{{days}} days left',
      limited: 'Limited {{quantity}}',
      free_shipping: 'Free Shipping',
      just_sold_seconds: '{{seconds}} Sec',
      just_sold_minutes: '{{minutes}} Min',
      just_sold_hours: '{{hours}} Hour',
      just_sold_ago: 'ago sold',
    },
    badge_sub: {
      free_shipping: 'Free Shipping',
      time_left_until_end: 'Until',
      time_left_seconds: ' {{seconds}}s',
      time_left_minutes: '<span>{{minutes}}</span><span>m left</span>',
      time_left_hours: '<span>{{hours}}</span><span>h left</span>',
      time_left_days: '<span>{{days}}</span><span>d left</span>',
      stock_left: '{{count}} Left',
      popular: 'Popular',
      limited: 'Limited {{quantity}}',
      trend: 'Trending',
    },
    count_view: {
      watching: '{{watcher_count}} people watching',
    },
    realtime: {
      seconds: '{{seconds}} Sec',
      minutes: '{{minutes}} Min',
      hours: '{{hours}} Hour',
      days: '{{days}} Day',
      sold_ago: 'ago sold!',
    },
    review: {
      review: 'Review',
    },
    shop: {
      watching: '{{watcher_count}} people watching',
    },
  },
  creator_view: {
    related_products: 'Related Products',
    latest_creator_view: 'Latest Creator View',
    see_more: 'View More',
  },
  preorder: {
    notable_pre_order_challenges: 'Pre-order Challenges',
    challenge: 'Challenge',
    section_title_pre_order_challenge: 'Pre-order Challenge',
    lnb_pre_order_challenge: 'Pre-order Challenge',
    gnb_pre_order_challenge: 'Pre-order Challenge',
    cta_participate_in_the_challenge: 'Join Challenge',
    cta_challenge_end: 'Challenge Ended',
    participated: '{{nickname}} joined.',
    challenge_success: 'Successful',
    challenge_failed: 'Ended',
  },
  digital_product_payment_completed: {
    receipt: {
      marppleshop_home: 'MarppleShop Home',
      order_list: 'Purchase History',
      order_completed: 'Order Completed',
      payment_completed: 'Payment Complete.',
      please_deposit_money: 'Please deposit by {{month}}/{{day}} {{hour}}:{{minute}}',
      share_it: 'Download your purchase certificate card and share it with friends!',
      download_now: 'Download now.',
      description_text_imp: 'After completing payment, download from Purchase History in My Page.',
      description_text:
        'Digital and e-book products purchased can be downloaded within the period from Purchase History in My Page.',
      download: 'Download',
    },
  },
  delivery_lead_time: {
    delivery_policy: {
      shipping_departure_date: 'Shipping Departure Date',
      select_departure_date: 'Select Departure Date',
      same_day_shipping: 'Same-day Shipping',
      within_business_days: 'Within {{business_day}} business days',
      hour: "by {{cutoff_time}} o'clock",
      upon_completion_of_payment: 'After payment completion',
    },
    product_detail: {
      ship_date_title: 'Shipping',
      ship_date_specific_date: 'Scheduled to ship from',
      ship_date_same_day: 'Scheduled to ship today, {{day}}',
      ship_date_same_day_cutoff_time: 'If paid by {{cutoff_time}}',
      ship_date_same_day_after: 'Scheduled to ship',
      sales_period_title: 'Sales Period',
      sales_period_from: 'Sales start from',
      sales_period_end: 'Sales end on',
    },
  },
};
